import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HelpdeskComponent } from '../Shared/helpdesk/helpdesk.component';
import { FormrenderService } from './formrender.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { CommondialogComponent } from '../../app/Shared/commondialog/commondialog.component';
import { fromEvent, Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { DialogService } from 'ng2-bootstrap-modal';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap';
import { UseraddService } from '../Master/useradd/useradd.service';
import { FormdashboardService } from '../dashboard/formdashboard/formdashboard.service';
import { RequestconfigService } from '../configuration/requestconfig/requestconfig.service';
import { saveFile, saveAs } from 'file-saver';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from '../../../src/environments/environment';
import { ContextMenuService } from 'ngx-contextmenu';
import { LocalService } from '../local.service';
import {encryptdecrypt} from '../encryptdecrypt';
import { cloneWithOffset } from 'ngx-bootstrap/chronos/units/offset';
import { UserService } from '../Master/user/user.service';
import {NgTinyUrlService} from 'ng-tiny-url';
//import { json } from 'node_modules1/@angular-devkit/core/src';

declare var $: any;


@Component({
  selector: 'app-formrender',
  templateUrl: './formrender.component.html',
  styleUrls: ['./formrender.component.css']
})
export class FormrenderComponent implements OnInit {
  sendMenuId: number = 37;
  p: number = 1;
  itemsPerPage: number = 10;
  sendPageName: string = 'Form Render';
  database: string = '';
  databaseName: string;
  databaseId: string;
  _formConfigList: any;
  searchText: string;
  htmlData: any;
  _formConfigListTmp: any = [];
  _databaseListTmp: any = [];
  _databaseList: any = [];
  _action: string;
  _master: any = [];
  submitted: boolean;
  userid: number;
  currentForm: string;
  formConfigid: number;
  formRenderForm: FormGroup;
  confmsg: string;
  msg: string;
  _masterList: any;
  formElement: any;
  fbEditorTouched: boolean;
  formData: any;
  base64string: string;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean;
  add: boolean;
  edit: boolean;
  delete: boolean;
  _menuId: any; _formData: any; valid: boolean;
  _usermappedDatabase = [];
  queryObj: any; dbid: string = ''; documentData: any; formConfigId: number = 0; _masterValues: any; mode: string = '';
  _allMasterList: any; documentId: any; menulist: any = [];
  dFormGroup: FormGroup = new FormGroup({});
  formConfigIdInput: number = 0;
  documentIdInput: number = 0;
	formConfigIdInput1: number ;
  documentIdInput1: number ;						  
  fileDownloadList: any = []; formDetailsList: any = [];
  createmode: boolean = false;
  statenetFulltextDatabaseId: number = 0;
  key: string = 'formname'; //set default
  reverse: boolean = false;
  pageInput: number = 1;
  userList = [];
	logList_Closed=[];
  logList=[];				
  filterTable = false;
  filterValue = '';
  isCustomSearch = false;
  customSearchData = '';
  itemsPerTable = 10;
  subPage = 1;
  selectedgroup: any;
  searchdata: any;
  selectedNodeText: any;
  columnsearchname: any;
  columnsearchgroup: any;

  isSort = false;
  sortingconditionValue = '';
  sortDirectionValue: any;
  isSortGroupBy = false;
  sortingconditionGroupBy: any;
  sortingDirectionGroupBy: any;
  customSearchSortConditionValue: any;
  sortingconditionValueGroupBy: any;
  selectedNodeValue: any;
  unreaddocumentids: any = [];
  formProfileList: any = [];

  formModalRef: BsModalRef;
  archiveyear = 0;
  archivedashboard = '';
  groupleveldata: any;

  //next unread
  formConfigForm: FormGroup;
  countConditionObj: any;
  getvaluesConditionObj: any;
  isadvancesearch = false;
  viewuserdetails = [];
  viewlogdetails = [];
  //context menu
  requestDetails = [];
  //autolog
  autolog = [];
  productline: any;
  product: any;
  productItems: any = [];
  _dropdownSettings: any;
  itemsPerPagesub=10;team:any;
  autologURL: any;showViewStatus=true;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  executableFileTypes=[];
  UserList: any;
  enc=new encryptdecrypt();
  public apitoken = this.localService.getJsonValue('apitoken');
  isautologuseronly=this.localService.getJsonValue('isautologuseronly');
  isautologteam= this.localService.getJsonValue('isautologteam'); 
  isautologadmin=this.localService.getJsonValue('isautologadmin');  
  userrole= this.localService.getJsonValue('userrole');
  autologUserTeamId:number=environment.autologUserTeamId;
  disabledSendBtn=true;_sendToAutoLog=false;
  isOpenNewTab=false;shortenedUrl:string='';CBAFormId:number=environment.CBAFormId;
  constructor(
    private formRenderService: FormrenderService,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer,
    private _frmBuilder: FormBuilder,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private useraddService: UseraddService,
    private formdashboardservice: FormdashboardService,
    private requestConfigService: RequestconfigService,
    private SpinnerService: NgxSpinnerService,
    private contextMenuService: ContextMenuService,
    private bsModelService: BsModalService,
    private localService: LocalService,
    private userservice: UserService,
    private tinyUrl: NgTinyUrlService
   
  ) {

    this.executableFileTypes=[{ 'type': 'exe'}, { 'type': 'sh'},{ 'type': 'js'},{ 'type': 'dll'},
    { 'type': 'bat'},{ 'type': 'bin'},{ 'type': 'job'},{ 'type': 'msi'},{ 'type': 'reg'},{ 'type': 'vb'}];
    
    this.route.queryParamMap.subscribe(params => {
      this.queryObj = params;
      if(this.queryObj.params.formDB !=undefined && this.queryObj.params.formDB!='')
      this.dbid = this.enc.decryptUsingAES256(this.queryObj.params.formDB.toString());//this.queryObj.params.formDB;
      else
      this.dbid=null;
      if(this.queryObj.params.db !=undefined && this.queryObj.params.db!='')
      this.databaseId = this.enc.decryptUsingAES256(this.queryObj.params.db.toString());//this.queryObj.params.db;
      if(this.queryObj.params.data !=undefined && this.queryObj.params.data!='')
      this.documentId = this.enc.decryptUsingAES256(this.queryObj.params.data.toString());//this.queryObj.params.data;
      else
      this.documentId =NaN;
     // this.documentId=this.queryObj.params.data;
      if(this.queryObj.params.formConfigId !=undefined && this.queryObj.params.formConfigId!='') 
      this.formConfigId =+this.enc.decryptUsingAES256(this.queryObj.params.formConfigId.toString());//+this.queryObj.params.formConfigId;
      else
      this.formConfigId =NaN;
      
      if(this.queryObj.params.mode !=undefined && this.queryObj.params.mode!='') 
      this.mode = this.enc.decryptUsingAES256(this.queryObj.params.mode.toString());//this.queryObj.params.mode;

    });


    const navigation = this.router.getCurrentNavigation();
   
    //let state:any;
   // if(navigation != undefined && navigation!=null){
    const state = navigation.extras.state as {

      data: any,
      formConfigId: any,
      mode: any,
      page: any,
      selectedgroup: any,
      searchdata: any,
      filterTable: any,
      filterValue: any,
      isCustomSearch: any,
      itemsPerPage: any,
      subPage:any,
      itemsPerPagesub:any,
      customSearchData: any,
      selectedNodeText: any,
      columnsearchname: any,
      columnsearchgroup: any,
      isSort: any,
      sortingconditionValue: any,
      sortDirectionValue: any,
      isSortGroupBy:any,
      sortingconditionGroupBy: any;
      sortingDirectionGroupBy: any;
      customSearchSortConditionValue: any;
      sortingconditionValueGroupBy: any;
      selectedNodeValue: any;
      archiveyear: any;
      groupleveldata: any;
      countConditionObj: any;
      getvaluesConditionObj: any;
      isadvancesearch: any;
      team:any;
    };
 // }
 /* else{
    state=null;
  }*/

    if (state != null && state != undefined) {


      this.documentId = state.data;
      this.formConfigId = + state.formConfigId;
      this.mode = state.mode;
      this.pageInput = +state.page;
      this.formConfigIdInput = +state.formConfigId;
      this.documentIdInput = +state.data;
      this.selectedgroup = state.selectedgroup;
      this.searchdata = state.searchdata;
      this.filterTable = state.filterTable;
      this.filterValue = state.filterValue;
      this.isCustomSearch = state.isCustomSearch;
      this.itemsPerTable = state.itemsPerPage;
      this.subPage = state.subPage;
      this.itemsPerPagesub=state.itemsPerPagesub;
      this.team=state.team;
      state.isCustomSearch ? this.customSearchData = state.customSearchData : '';
      this.selectedNodeText = state.selectedNodeText;
      this.columnsearchname = state.columnsearchname;
      this.columnsearchgroup = state.columnsearchgroup;
      this.isSort = state.isSort,
        this.sortingconditionValue = state.sortingconditionValue,
        this.sortDirectionValue = state.sortDirectionValue
      this.isSortGroupBy = state.isSortGroupBy;
      this.sortingconditionGroupBy = state.sortingconditionGroupBy;
      this.sortingDirectionGroupBy = state.sortingDirectionGroupBy;
      this.customSearchSortConditionValue = state.customSearchSortConditionValue;
      this.sortingconditionValueGroupBy = state.sortingconditionValueGroupBy;
      this.selectedNodeValue = state.selectedNodeValue;
      this.team=state.team;
      if (state.archiveyear != undefined)
        this.archiveyear = state.archiveyear;
      this.groupleveldata = state.groupleveldata;
      this.countConditionObj = state.countConditionObj != null && state.countConditionObj != undefined ? JSON.parse(state.countConditionObj) : null;
      this.getvaluesConditionObj = state.getvaluesConditionObj != null && state.getvaluesConditionObj != undefined ? JSON.parse(state.getvaluesConditionObj) : null;
      this.isadvancesearch = state.isadvancesearch == null || state.isadvancesearch == undefined ? false : state.isadvancesearch;
															
    this.formConfigIdInput1=this.formConfigIdInput;
    this.documentIdInput1=this.documentIdInput;
    //  this.documentIdInput = +this.queryObj.params.data;
    }else{
      this.formConfigIdInput1=this.formConfigId;
      this.documentIdInput1=this.documentId;
    }



  }
  ngOnInit() {
    this.SpinnerService.show();
    this.formConfigForm = this._frmBuilder.group({
      ProductLine: ['', ],
      Product: ['', ], 
    });

    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    //this.route.queryParamMap.subscribe(params => {

    //  this.queryObj = params;
    //  this.dbid = this.queryObj.params.formDB;
    //  this.documentId = this.queryObj.params.data; this.formConfigId = +this.queryObj.params.formConfigId;
    //  this.mode = this.queryObj.params.mode;
    //  this.pageInput = +this.queryObj.params.page;
    //  this.formConfigIdInput = +this.queryObj.params.formConfigId;
    //  this.documentIdInput = +this.queryObj.params.data;
    //});
   //this.route.queryParamMap.subscribe(params => {
    //  this.queryObj = params;
    //  this.dbid = this.queryObj.params.formDB;
    //  this.databaseId = this.queryObj.params.db;
    //  this.documentId = this.queryObj.params.data; this.formConfigId = +this.queryObj.params.formConfigId;
    //  this.mode = this.queryObj.params.mode;
    //  this.pageInput = +this.queryObj.params.page;
    //  this.formConfigIdInput = +this.queryObj.params.formConfigId;
    //  this.documentIdInput = +this.queryObj.params.data;
    //  this.selectedgroup = this.queryObj.params.selectedgroup;
    //  this.searchdata = this.queryObj.params.searchdata;
    //  this.filterTable = this.queryObj.params.filterTable;
    //  this.queryObj.params.filterValue != undefined ? this.filterValue = this.queryObj.params.filterValue : '';
    //  this.isCustomSearch = this.queryObj.params.isCustomSearch;
    //  this.itemsPerTable = this.queryObj.params.itemsPerPage == undefined ? 10 : this.queryObj.params.itemsPerPage;
    //  this.subPage = this.queryObj.params.subPage == undefined ? 1 : this.queryObj.params.subPage;
    //  this.isCustomSearch ? this.customSearchData = this.queryObj.params.customSearchData : '';
    //  this.selectedNodeText = this.queryObj.params.selectedNodeText;
    //});
    this.formRenderForm = this._frmBuilder.group({
      dbid: ['', [Validators.required]],
      formconfigid: ['', [Validators.required]]

    });
    if (this.mode != 'View') {
      this.getActionRightsList();
    }
    if(this.mode =='newtab'){
      this.isOpenNewTab=true;
    }
    if (this.archiveyear != 0 && this.archiveyear != undefined) {
      this.archivedashboard = 'Archive ';
    }
    else
      this.archivedashboard = '';
    this.getActionRightsList();
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    // this.LoadAllMasterDetails();
    this._formConfigList = [];
    this._databaseList = [];
    this.searchText = '';
    this.htmlData = '';
    this._action = 'add';
    this.formElement = '';
    this.valid = true;
    this.loadFormConfig();
    this.loadDatabaseList();
    //this.LoadMasterList();
    this.ActivityLog();
    this.LoadAllUserList();   
    //this.loadproduct(0, 'Null', 1);
    this.loadproductline(0, 'Null', 1);
if((this.isautologuseronly==1 &&  this.isautologteam==this.autologUserTeamId
  && this.userrole=='Admin') ||((this.isautologuseronly==1 &&  this.isautologteam==this.autologUserTeamId
   && this.isautologadmin==1))
         ||(this.isautologuseronly==2)){
this.disabledSendBtn=false;
         }
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getActionRightsList() {
    this.useraddService.GetById(this.userid).subscribe(res => {
      let allUser: any = [];
      allUser = res.find(y => y.userid == this.userid);
      var data = JSON.parse(allUser.menumapped);
      //console.log(data);
      if (data != null && data != undefined && data.length != 0) {
        data = data.filter(e => e.menuid == 37);
        if (data != null && data != undefined && data.length != 0)
          this._actionRights = data[0].action;
        else
          this._actionRights = [];
      }

      var btnToEnable = this._actionRights;
      if (btnToEnable.length > 0) {
        btnToEnable.forEach(d => {
          if (d != undefined) {
            if (d == 1) {
              this.readOnly = true;
              setTimeout(function () {
                $('#formrender input').keydown(function (event) {
                  //  alert('test')
                  var ctrlDown = event.ctrlKey || event.metaKey;
                  var copypaste = (event.keyCode == 67 && ctrlDown) || (event.keyCode == 65 && ctrlDown);
                  if (!copypaste) {
                    event.preventDefault();
                  }
                  // event.preventDefault();
                });
              }, 6000);
              setTimeout(function () {
                $('#formrender .form-control').keydown(function (event) {
                  //  alert('test')
                  var ctrlDown = event.ctrlKey || event.metaKey;
                  var copypaste = (event.keyCode == 67 && ctrlDown) || (event.keyCode == 65 && ctrlDown);
                  if (!copypaste) {
                    event.preventDefault();
                  }
                  // event.preventDefault();
                });
              }, 6000);

            }
            else if (d == 2) {

              this.add = true;
              this.submitShow = true;


            }
            else if (d == 3) {

              this.edit = true;
              // this.submitShow = true;
            }
            else if (d == 4) {

              this.delete = true;
            }
          }
        });
        //if (this.add == true) {
        //  $("#btnsumbit").css('visibility', 'visible');
        //  $("#btnclear").css('visibility', 'visible');
        //}
        //if (this.add == false) {
        //  $("#btnsumbit").css('visibility', 'hidden');
        //  $("#btnclear").css('visibility', 'hidden');
        //}
        //if ((this.edit == true) && (this.dbid != null)) {
        //  $("#btnsumbit").css('visibility', 'visible');
        //  $("#btnclear").css('visibility', 'hidden');
        //}
        //if ((this.edit == false) && (this.dbid != null)) {
        //  $("#btnsumbit").css('visibility', 'hidden');
        //  $("#btnclear").css('visibility', 'hidden');
        //}
      }
    });

  }

  close() {
    this.bsModalRef.hide();
  }

  LoadMasterList() {
    this.formRenderService.getmaster().toPromise().then(master => {
      this._master = master;
    });
  }

  loadDatabaseList() {
    this.SpinnerService.show();
    Promise.all([this.formRenderService.getDatabase().toPromise(), this.useraddService.GetById(this.userid).toPromise()]).then(
      ([result1, result2]) => {
        let allData = result1;
        this.userList = result2;
        allData.forEach(data => {
          if (data.active != 0) {
            let user: any = [];
            user = this.userList.find(y => y.userid == this.userid);
            this._usermappedDatabase = JSON.parse(user.databasemapped).databasemapped;
            if ((this._usermappedDatabase != undefined) && (this._usermappedDatabase != null) && (this._usermappedDatabase.length > 0)) {
              let s = this._usermappedDatabase.filter(e => e.databaseid == data.databaseid);
              if ((s != undefined) && (s.length != 0)) {
                this._databaseListTmp.push({ databaseid: data.databaseid, database: data.database });
              }
            }
            else {
              this._databaseListTmp = [];
            }
            this._databaseList = JSON.parse(JSON.stringify(this._databaseListTmp));
          }
        });


        this.formRenderForm.controls['dbid'].setValue(0);
        if (isNaN(this.formConfigId))// || (this.dbid == '' || this.dbid != undefined))
        {
          this._action = 'add';
          //if (this.add == false || this.add == undefined) {
          //  $("#btnsumbit").css('visibility', 'hidden');
          //  $("#btnclear").css('visibility', 'hidden');
          //}
          //else {
          //  $("#btnsumbit").css('visibility', 'visible');
          //  $("#btnclear").css('visibility', 'visible');
          //}
          // this.database = this.route.snapshot.paramMap.get('db');
          this.database = this.databaseId;
          if (this.database != null) {
            var a = this.database.split('*');
            this.databaseId = a[0];
            this.databaseName = a[1];
            this.formRenderForm.controls['dbid'].setValue(this.databaseId);
            this.loadFormConfig();
          }
          else
            this.formRenderForm.controls['dbid'].setValue(0);
        }
        else {
          if (this.dbid != null) {
            this._action = 'update';
            $("#dbid").prop('disabled', 'true');
            $("#formconfigid").prop('disabled', 'true');
            //   $("#btnclear").prop('disabled', 'true');
            $("#btnclear").css('visibility', 'hidden');
            if (this.edit == false || this.edit == undefined) {
              $("#btnsumbit").css('visibility', 'hidden');
            }
            else {
              $("#btnsumbit").css('visibility', 'visible');
            }
            var a = this.dbid.split('*');
            this.databaseId = a[0];
            this.databaseName = a[1];
            this.formRenderForm.controls['dbid'].setValue(this.databaseId);
           
            this.loadFormRenderView();
            //this.loadFormConfig();countConditionObj

            //code to hide fulltext file control

          }
        }
        // this.SpinnerService.hide();
      }, error => {
        this.SpinnerService.hide();

        this.toastr.error('Error while getting the database data');
      });


  }


  //Backtoformlist() {
  //  if (isNaN(this.pageInput)) {
  //    this.pageInput = 1;
  //  }
  //  if (this.dbid != null && this.formConfigId != null && this.formConfigId != 0 && !isNaN(this.formConfigId)) {
  //    this.router.navigate(['/home/formdashboard', {
  //      'db': this.databaseId, 'formconfigid': this.formConfigId, 'fromrender': 1, 'page': this.pageInput
  //    }]);
  //  }
  //  else {
  //    this.router.navigate(['/home/formdashboard', { 'db': this.databaseId, 'formconfigid': 0, 'fromrender': 1, 'page': this.pageInput }]);
  //  }
  //  if (this.databaseId != null && this.formConfigId != null && this.formConfigId != 0 && !isNaN(this.formConfigId))
  //    this.router.navigate(['/home/formdashboard', { 'db': this.databaseId, 'formconfigid': this.formConfigId, 'fromrender': 1, 'page': this.pageInput }]);
  //  else {
  //    this.router.navigate(['/home/formdashboard', { 'db': this.databaseId, 'formconfigid': 0, 'fromrender': 1, 'page': this.pageInput }]);
  //  }
  //}

  Backtoformlist() {

    //if (this.mode == 'add') {
    //  this.router.navigate(['/home/formdashboard'], { queryParams: { 'db': this.databaseId } });
    //  return;
    //}

    if (this.mode == 'addByDashboard') {
      this.router.navigate(['/home']);
      return;
    }

    let queryParams = {};
    queryParams['db'] = this.enc.encryptUsingAES256(this.databaseId.toString());//this.databaseId;
    //queryParams['page'] = this.pageInput;
    //queryParams['selectedgroup'] = this.selectedgroup;
    //queryParams['searchdata'] = this.searchdata;
    //queryParams['filterTable'] = this.filterTable;
    //queryParams['filterValue'] = this.filterValue;
    //queryParams['isCustomSearch'] = this.isCustomSearch;
    //queryParams['itemsPerPage'] = this.itemsPerTable;
    //queryParams['subPage'] = this.subPage == undefined ? 1 : this.subPage;
    //queryParams['selectedNodeText'] = this.selectedNodeText;
    //this.isCustomSearch ? queryParams['customSearchData'] = this.customSearchData : '';

    //if (this.dbid != null && this.formConfigId != null && this.formConfigId != 0 && !isNaN(this.formConfigId)) {
    //  queryParams['formconfigid'] = this.formConfigId;
    //  queryParams['fromrender'] = 1;
    //  this.router.navigate(['/home/formdashboard'], { queryParams: queryParams });
    //} else {
    //  queryParams['formconfigid'] = this.formConfigId;
    //  queryParams['fromrender'] = 1;
    //  this.router.navigate(['/home/formdashboard'], { queryParams: queryParams });
    //}
const navigationExtras: NavigationExtras = {
      queryParams,
      state: {
        db: this.databaseId,
        formDB: this.dbid,
        data: this.documentId ,
        formConfigId: this.formConfigId,
        mode: this.mode ,
        page: this.pageInput ,
        selectedgroup: this.selectedgroup ,
        searchdata: this.searchdata ,
        filterTable: this.filterTable,
        filterValue: this.filterValue ,
        isCustomSearch: this.isCustomSearch ,
        itemsPerPage: this.itemsPerTable ,
        customSearchData: this.customSearchData,
        selectedNodeText: this.selectedNodeText,
        fromrender: 1,
        subPage: this.subPage,
        columnsearchname: this.columnsearchname,
        columnsearchgroup: this.columnsearchgroup,
        isSort : this.isSort,
        sortingconditionValue: this.sortingconditionValue,
        sortDirectionValue: this.sortDirectionValue,
        isSortGroupBy: this.isSortGroupBy,
        sortingconditionGroupBy: this.sortingconditionGroupBy,
        sortingDirectionGroupBy: this.sortingDirectionGroupBy,
        customSearchSortConditionValue: this.customSearchSortConditionValue,
        sortingconditionValueGroupBy: this.sortingconditionValueGroupBy,
        selectedNodeValue: this.selectedNodeValue,
        archiveyear: this.archiveyear,
        groupleveldata: this.groupleveldata,
        countConditionObj: JSON.stringify(this.countConditionObj),
        getvaluesConditionObj: JSON.stringify(this.getvaluesConditionObj),
        isadvancesearch: this.isadvancesearch
      }
    };

    this.router.navigate(['/home/formdashboard'], navigationExtras);

  }
  onDatabaseChange(eve) {

    this._formConfigListTmp = this._formConfigList.filter(e => e.dbid == eve.target.value && e.active == 1);
    this.formData = '';
    this.loadhtmldata(this.formData);
  }

  onformChange(eve) {


    var selectedValue = eve.target.value;
    this.formConfigId = selectedValue;
    if (this._formConfigList.length != 0) {
      var s = this._formConfigList.filter(e => e.formconfigid == selectedValue);
      if ((s != undefined) && (s.length != 0)) {
        this.htmlData = s[0].htmldata;
        var arr = JSON.parse(s[0].htmldata);
        //get list of field alias name
        if (arr.length > 0) {
          arr.forEach(item => {
            if (item.name != undefined) {
              this.formRenderForm.addControl(item.name, new FormControl('', []));
            }
          });
        }
        var htmData = JSON.parse(s[0].htmldata);
        if (htmData.length > 0) {
          var tabledetails = htmData.filter(e => e.tablename != undefined && e.tablename != '' && e.tablename != null)
          var tableid = '';
          if (tabledetails.length != 0) {
            tabledetails.forEach(p => {
              var s = p.values.filter(e => e.selected == true)[0].value;
              if (s != undefined && s != null && s.length != 0) {
                if (tableid == '')
                  tableid = s;
                else
                  tableid = tableid + ',' + s;
              }
            });
          }
          if (tableid != '') {
            this.formRenderService.GetAllGivenMasterDetails(tableid).subscribe(res => {
              if (res != undefined && res != null) {
                this._allMasterList = [];
                this._allMasterList = res;
                var cleanedData = this.validFormData(s[0].htmldata);
                this.loadhtmldata(cleanedData);
              }
            });
          }
          else {
            var cleanedData = this.validFormData(s[0].htmldata);
            this.loadhtmldata(cleanedData);
          }
        }

        if (selectedValue == "194") {
          $('.form-group[class*="field-fileFullText"]').css('display', 'none');
          $('.form-group[class*="field-filefulltext"]').css('display', 'none');
        }

      }
      else
        this.htmlData = '';
    }
  }

  validFormData(data) {
    this._formData = JSON.parse(data);
    if (this._formData.length > 0) {
      this.isDependentSelectMaster(this._formData);
      this._formData.forEach((item, index) => {
        if (item.name != undefined) {
          if ((item.type == 'radio-group' && item.description == 'Masters') || (item.type == 'checkbox-group' && item.description == 'Masters')) {
            var selected = ''; var tableid = '';
            var exists = 0;
            var g = item.values.filter(function (e) { return e.selected == true; });
            if (g != undefined && g != null && g.length != 0) {
              selected = g[0].label; tableid = g[0].value;
            }
            if ((item.type == "checkbox-group") && (item.description == 'Masters') && (item.values.length <= 1)) {
              item.description = '';
              item.label = '';
            }
            //check the drop down is master with the help of selected value and id
            if (selected != '') {
              var tableName = '';
              tableName = selected.replace(/\s/g, '').trim();
              if ((this._allMasterList != undefined) && (this._allMasterList.length != 0)) {
                for (let data of this._allMasterList) {
                  for (var i = 0; i < item.values.length; i++) {
                    var rendername = '';
                    rendername = 'tbl' + tableName.toLowerCase().trim() + 'master';
                    //master datas
                    var s = this._allMasterList.filter(e => e.tblname == rendername && e.masterid == tableid);
                    if (s.length != 0) {
                      var templist = [];
                      if ((item.type == 'select') && ((item.multiple != true) || (item.multiple == undefined))) {
                        templist.push({ label: 'Select ' + selected.toLowerCase(), value: 0 });
                      }

                      // this._masterValues = JSON.parse(s[0].mastervalues);
                      if (this.mode == 'View') {
                        var _masterAtViewMode = this.assignMasterDataInViewMode(item.formcontrolname, this.formDetailsList, JSON.parse(s[0].mastervalues), tableName.toLowerCase());
                        this._masterValues = _masterAtViewMode;
                      }
                      else {
                        var _masterDataActiveandInactive = JSON.parse(s[0].mastervalues);
                        if (_masterDataActiveandInactive.length != 0) {
                          this._masterValues = _masterDataActiveandInactive.filter(e => e.active == 1);
                        }
                      }

                      if (this._masterValues != null && this._masterValues != undefined && this._masterValues.length != 0) {
                        for (var i = 0; i < this._masterValues.length; i++) {
                          templist.push({
                            label: this._masterValues[i][tableName.toLowerCase()],
                            value: this._masterValues[i][tableName.toLowerCase() + "id"]
                          });

                        }
                      }
                      item.values = [];
                      templist.sort((a, b) => a.label.localeCompare(b.label));
                      item.values = templist;
                      //remove the help text from the master control
                      item.description = '';
                      this._formData[index]["masters"] = 'Masters';
                    }
                  }
                }
              }
            }
          }
          else {
            if ((item.type == 'select' && item.masters != 'Masters')) {
              var templist = [];
              var _data = item.values;
              templist.push(
                {
                  label: 'Please choose the required value',
                  value: 0
                });
              for (var i = 0; i < _data.length; i++) {
                templist.push({
                  label: _data[i].label,
                  value: _data[i].value
                });
              }
              item.values = [];
              item.values = templist;
            }
          }
        }
      });
      //  })
      // }
    }
    return JSON.stringify(this._formData);
  }

  assignMasterDataInViewMode(formcontrolname, formDetailsList, masterValues, tableName) {
    var _selectedMasterValues = [];
    if (masterValues != undefined && masterValues != null && masterValues.length != 0) {
      _selectedMasterValues = masterValues.filter(e => e.active == 1);
      if (formDetailsList.length != 0) {
        var userSelectedValues = formDetailsList[0][formcontrolname.toLowerCase()];
        if (userSelectedValues != undefined && userSelectedValues.length != null && userSelectedValues.length != 0) {
          var inactiveMasterValues = masterValues.filter(e => e.active == 0);
          if (inactiveMasterValues != undefined && inactiveMasterValues != null && inactiveMasterValues.length != 0) {
            userSelectedValues.forEach(i => {
              if (i != null) {
                for (var k = 0; k < inactiveMasterValues.length; k++) {
                  if (inactiveMasterValues[k][tableName.toLowerCase() + "id"] == i.selectedid && inactiveMasterValues[k]["active"] == 0) {
                    _selectedMasterValues.push(inactiveMasterValues[k]);
                  }
                }
              }
            })
          }

        }
      }
    }
    return _selectedMasterValues;
  }


  //check for dependent master
  isDependentSelectMaster(data) {
    console.log(this.documentIdInput);
    var s = data.filter(function (e) { return e.type == 'select' && e.description == 'Masters'; });
    const selectItem = s;//this._formData.filter(function (e) { return e.type == 'select' && e.description == 'Masters' });
    if (s != undefined && s != null && s.length != 0) {
      var selected = ''; var tableid = ''; var tableName = '';
      s.forEach((u) => {
        var val = u.values;
        if (val != undefined && val != null && val.length != 0) {
          var a = val.filter(function (e) { return e.selected == true; });
          if (a != undefined && a != null && a.length != 0) {
            selected = a[0].label; tableid = a[0].value;
          }
          tableName = selected.replace(/\s/g, '').trim();
          //check with master details
          var rendername = ''; var _masterValues = ''; var templist = [];
          rendername = 'tbl' + tableName.toLowerCase().trim() + 'master';
          var depData = this._allMasterList.filter(e => e.tblname == rendername && e.masterid == tableid);
          var allMasterList = this._allMasterList;
          if (depData != undefined && depData != null && depData.length != 0) {
            //if  the dropdown is dependent
            if (depData[0].dependentmasterid != undefined && depData[0].dependentmasterid != 0) {

              var isExists = s.filter((o) => o.values.some((e) => e.value == depData[0].dependentmasterid && e.selected == true));
              var _isExists = s.filter(e => e.tablemasterid == depData[0].dependentmasterid);
              if ((isExists != undefined && isExists != null && isExists.length != 0) || (_isExists != undefined && _isExists != null && _isExists.length != 0)) {
                var elementID = ''; var _label = '';
                if (isExists.length != 0) {
                  elementID = isExists[0].formcontrolname;
                  _label = isExists[0].label + 'id';
                }
                if (_isExists.length != 0) {
                  elementID = _isExists[0].formcontrolname;
                  _label = _isExists[0].label + 'id';
                }
                var dependentmasterid = depData[0].dependentmasterid;
                var str = depData[0].dependentmasterid + '*' + u.formcontrolname + '*' + _label;
                $(document).on('change', '#' + elementID, str, function (e) {
                  var b = str.split('*');
                  var f = allMasterList.filter(e => e.dependentmasterid == b[0]);
                  var selectedText = f[0].mastername;
                  var selectedId = e.target.value;
                  var selectedTableName = f[0].tblname;
                  var select = document.getElementById(b[1]);
                  //if (document.getElementById(b[1])== null) {
                  // var n = b[1].slice(0, -1);
                  // var selectors = '[id^=' + n + ']';
                  //  var name = document.querySelector(selectors).id;

                  //}
                  //else {
                  //// (<HTMLElement>select).options.length

                  //}
                  (<HTMLSelectElement>select).options.length = 0;
                  // select.options.length = 0;
                  var _option = document.createElement("option");
                  _option.text = 'Select ' + selectedText.toLowerCase();
                  _option.value = '0';
                  select.appendChild(_option);

                  if (f != undefined && f != null && f.length != 0) {
                    b[2] = b[2].replace(/\s/g, '').toLowerCase().trim();
                    // var items = JSON.parse(f[0].mastervalues).filter(e => e[b[2]] == selectedId);
                    if (this.mode == 'View') {
                      var _masterAtViewMode = this.assignMasterDataInViewMode(u.formcontrolname, this.formDetailsList, JSON.parse(f[0].mastervalues).filter(e => e[b[2]] == selectedId),
                        tableName.toLowerCase());
                      var items = _masterAtViewMode
                    }
                    else {
                      var items = JSON.parse(f[0].mastervalues).filter(e => e[b[2]] == selectedId && e.active == 1);
                    }

                    if (items != undefined && items != null && items.length != 0) {
                      for (var i = 0; i < items.length; i++) {
                        var option = document.createElement("option");
                        option.text = items[i][f[0].mastername.replace(/\s/g, '').trim().toLowerCase()];
                        option.value = items[i][f[0].mastername.replace(/\s/g, '').trim().toLowerCase() + "id"];
                        select.appendChild(option);
                      }
                    }
                  }
                });
                templist = [];
                templist.push({ label: 'Select ' + selected.toLowerCase(), value: 0 });
                u.values = [];
                if (this._action != 'add') {
                  var res = this.formDetailsList;
                  if (res != undefined && res != null && res.length != 0) {
                    //var allData = JSON.parse(res[0].formdetails).filter(e => e["documentid"] == this.documentIdInput);
                    var allData = res[0];
                    if (allData != undefined && allData != null && allData.length != 0) {
                      if (allData[elementID.toLowerCase()] != undefined && allData[elementID.toLowerCase()] != null && allData[elementID.toLowerCase()] != '') {
                        var f = allMasterList.filter(e => e.dependentmasterid == depData[0].dependentmasterid);
                        if (f != undefined && f != null && f.length != 0) {
                          // _label = _label.toLowerCase().trim();
                          _label = _label.replace(/\s/g, '').toLowerCase().trim();
                          //var items = JSON.parse(f[0].mastervalues).filter(e => e[_label] == allData[elementID.toLowerCase()][0].selectedid);
                          if (this.mode == 'View') {
                            let _masterAtViewMode: any = [];
                            _masterAtViewMode = this.assignMasterDataInViewMode(u.formcontrolname, this.formDetailsList, JSON.parse(f[0].mastervalues).filter(e => e[_label] == allData[elementID.toLowerCase()][0].selectedid), tableName.toLowerCase());
                            var items = _masterAtViewMode
                          }
                          else {
                            var items = JSON.parse(f[0].mastervalues).filter(e => e[_label] == allData[elementID.toLowerCase()][0].selectedid && e.active == 1);
                          }

                          if (items != undefined && items != null && items.length != 0) {
                            for (var i = 0; i < items.length; i++) {
                              templist.push({ label: items[i][tableName.toLowerCase()], value: items[i][tableName.toLowerCase() + "id"] });
                              //if (items[i]["active"] != 0) {
                              //  templist.push({ label: items[i][tableName.toLowerCase()], value: items[i][tableName.toLowerCase() + "id"] });
                              //}
                              //else {
                              //  templist.push({ label: items[i][tableName.toLowerCase()], value: items[i][tableName.toLowerCase() + "id"], disabled: 'true' });
                              //}

                            }
                            u.values = templist;
                            u.description = '';
                            u["masters"] = 'Masters';
                          }
                        }
                      }
                    }
                  }

                }
                u.values = templist;
                u.description = '';
                u["masters"] = 'Masters';
                u['tablemasterid'] = tableid;
              }
              else {
                //change the item value
                u['tablemasterid'] = tableid;
                templist = [];
                if ((u.multiple != true) || (u.multiple == undefined)) {
                  templist.push({ label: 'Select ' + selected.toLowerCase(), value: 0 });
                 // _masterValues = JSON.parse(depData[0].mastervalues);
                  if (this.mode == 'View') {
                    let _masterAtViewMode: any = [];
                    _masterAtViewMode = this.assignMasterDataInViewMode(u.formcontrolname, this.formDetailsList, JSON.parse(depData[0].mastervalues), tableName.toLowerCase());
                    _masterValues = _masterAtViewMode
                  }
                  else {
                    _masterValues = JSON.parse(depData[0].mastervalues).filter(e => e.active == 1);
                  }

                  for (var i = 0; i < _masterValues.length; i++) {
                    templist.push({ label: _masterValues[i][tableName.toLowerCase()], value: _masterValues[i][tableName.toLowerCase() + "id"] });
                   // templist.push({ label: _masterValues[i][tableName.toLowerCase()], value: _masterValues[i][tableName.toLowerCase() + "id"] });
                    //if (_masterValues[i]["active"] != 0) {
                    //  templist.push({ label: _masterValues[i][tableName.toLowerCase()], value: _masterValues[i][tableName.toLowerCase() + "id"] });
                    //}
                    //else {
                    //  templist.push({ label: _masterValues[i][tableName.toLowerCase()], value: _masterValues[i][tableName.toLowerCase() + "id"], disabled: 'true' });
                    //}


                  }
                  u.values = [];
                  u.values = templist;
                  //remove the help text from the master control
                  u.description = '';
                  u["masters"] = 'Masters';
                }
              }
            }
            else {
              //change the item value
              u['tablemasterid'] = tableid;
              templist = [];
              if ((u.multiple != true) || (u.multiple == undefined)) {
                templist.push({ label: 'Select ' + selected.toLowerCase(), value: 0 });
               // _masterValues = JSON.parse(depData[0].mastervalues);
                if (this.mode == 'View') {
                  let _masterAtViewMode: any = [];
                  _masterAtViewMode = this.assignMasterDataInViewMode(u.formcontrolname, this.formDetailsList, JSON.parse(depData[0].mastervalues), tableName.toLowerCase());
                  _masterValues = _masterAtViewMode
                }
                else {
                  _masterValues = JSON.parse(depData[0].mastervalues).filter(e => e.active == 1);
                }

                for (var i = 0; i < _masterValues.length; i++) {
                  templist.push({ label: _masterValues[i][tableName.toLowerCase()], value: _masterValues[i][tableName.toLowerCase() + "id"] });
                  //if (_masterValues[i]["active"] != 0) {
                  //  templist.push({ label: _masterValues[i][tableName.toLowerCase()], value: _masterValues[i][tableName.toLowerCase() + "id"] });
                  //}
                  //else {
                  //  templist.push({ label: _masterValues[i][tableName.toLowerCase()], value: _masterValues[i][tableName.toLowerCase() + "id"], disabled: 'true' });
                  //}

                }
                u.values = [];
                u.values = templist;
                //remove the help text from the master control
                u.description = '';
                u["masters"] = 'Masters';
              }
            }
          }
        }
      });
    }
  }

  clearForm() {   
    this.formRenderForm.reset();
    this._action = 'add';
    this.formRenderForm.controls['dbid'].setValue(0);
    this.formRenderForm.controls['formconfigid'].setValue(0);   
    this.loadhtmldata(this.formData);
    this.formData = '';
    this._formConfigListTmp = [];
    // this.loadFormConfig();
  }

  //loadhtmldata(formdata: any) {
  //  
  //  this.formData = formdata;
  //  const formData = formdata;
  //  const escapeEl = document.createElement("textarea");
  //  const code = document.getElementById("markup");
  //  const addLineBreaks = html => html.replace(new RegExp("><", "g"), "><");
  //  const $markup = $("<div/>");
  //  $markup.formRender({ formData });
  //  code.innerHTML = addLineBreaks($markup.formRender("html")).replace('<textarea type="textarea" class="form-control" name="txtareaFullText3" rows="35" formcontrolname="txtareaFullText3" id="txtareaFullText3"></textarea>','<div></div>');

  //}
  LoadAllUserList() {
       let a= new encryptdecrypt();
    this.userservice.Get().toPromise().then(res => {
      // console.log(res);
       res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
      this.UserList = res;
      this.loadformdashboarddetails();
     // this.LoadSearchedFormDetails(1);

    }, error => { this.toastr.error('Error while getting users data') });

  }

  loadhtmldata(formdata: any) {
    let data = JSON.parse(formdata);
    let selectedDb = this._databaseList.filter(x => this.formRenderForm.value.dbid == x.databaseid);
    let textfulltext = data.filter(x => x.formcontrolname.toLowerCase().trim().includes('txtareafulltext'));
    let publishDate = data.filter(x => x.formcontrolname.toLowerCase().trim().includes('datepublishdate'));
    console.log('textfulltext: ', textfulltext);
    let istxtareafulltext3 = '';
    let formControlName = '';
    let rows = 0;
    if (textfulltext.length > 0 && selectedDb[0].database == 'Non Case Law') {
      istxtareafulltext3 = textfulltext[0].value;
      formControlName = textfulltext[0].formcontrolname;
      rows = textfulltext[0].rows;
      data.forEach(element => {
        if (element.formcontrolname.toLowerCase().trim().includes('txtareafulltext')) {
          element.value = '';
        }
      });
      formdata = JSON.stringify(data);
    }
    this.formData = formdata;
    const formData = formdata;
    const escapeEl = document.createElement("textarea");
    const code = document.getElementById("markup");
    const addLineBreaks = html => html.replace(new RegExp("><", "g"), "><");
    const $markup = $("<div/>");
    $markup.formRender({ formData });
    let htmlValue = '';
    if (istxtareafulltext3 == '' || istxtareafulltext3 == null || istxtareafulltext3 == undefined) {
      if (textfulltext.length > 0 && selectedDb[0].database == 'Non Case Law') {
        htmlValue = addLineBreaks($markup.formRender("html")).replace('<textarea type="textarea" class="form-control" name="' + formControlName + '" rows="' + rows + '" formcontrolname="' + formControlName + '" id="' + formControlName + '"></textarea>', '<div></div>');
        if (publishDate.length > 0 && selectedDb[0].database == 'Non Case Law' && this.mode == 'View') {
          htmlValue = htmlValue.replace('id="' + publishDate[0].formcontrolname + '"', 'id="' + publishDate[0].formcontrolname + '" disabled ');
        }
        htmlValue = htmlValue.replace('<div class="fb-file form-group field-fileFullTextFile7">', '<div class="fb-file form-group field-fileFullTextFile7" style = "display:none;" >');
      }
      else
        htmlValue = addLineBreaks($markup.formRender("html"));
    } else {
      htmlValue = addLineBreaks($markup.formRender("html")).replace('<textarea type="textarea" class="form-control" name="' + formControlName + '" rows="' + rows + '" formcontrolname="' + formControlName + '" id="' + formControlName + '"></textarea>', '<div class="anchor-underline">' + istxtareafulltext3 + '</div>');
      if (publishDate.length > 0 && selectedDb[0].database == 'Non Case Law' && this.mode == 'View') {
        htmlValue = htmlValue.replace('id="' + publishDate[0].formcontrolname + '"', 'id="' + publishDate[0].formcontrolname + '" disabled ');
        htmlValue = htmlValue.replace('<div class="fb-file form-group field-fileFullTextFile7">', '<div class="fb-file form-group field-fileFullTextFile7" style = "display:none;" >');
      }
    }
    code.innerHTML = htmlValue;
    this.SpinnerService.hide();
  }

  validateInputs(data) {
    var valueList = data;
    if ((valueList != undefined) && (valueList.length != 0)) {
      var s = valueList.filter(e => e.value == 1);
      if (s == undefined || s.length == 0) {
        return 1;
      }
      else {
        return 0;
      }
    }
  }

  getSelectedid(data) {
    var selected = [];
    data.forEach(a => {
      if (a.value == 1)
        selected.push(
          {
            selectedid: a.name
          });
    });
    return selected;
  }

  postFormRender(form: any,formconfig:any,isautologsubmit:boolean) {
    let allocationvalidation = {};


    this.submitted = true;
    if (this.formRenderForm.valid) {
      if (this.formRenderForm.get('dbid').value == 0) {
        this.toastr.error('Database should be selected');
        return;
      }
      if (this.formRenderForm.get('formconfigid').value == 0) {
        this.toastr.error('form Template should be selected');
        return;
      }
      this.SpinnerService.show();
      //  $("#btnsumbit").css('visibility', 'hidden');
      $("#btnsumbit").prop('disabled', 'true');
      var validList = [];
      var validFileList = [];
      const formData = new FormData();
      var arr = this._formData;//JSON.parse(this.htmlData);
      //get list of field alias name
      if (arr.length > 0) {
        arr.forEach(item => {
          if (item.name != undefined) {
            var txt = item.name.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, '');
            txt = txt.toLowerCase();
            if (item.type == 'file') {
              var input: any = document.getElementById(item.name);
              var file: File = input.files[0];
              if((this.formRenderForm.get('formconfigid').value==this.CBAFormId) 
              && (this._action=='add') && (file==undefined))
              validList.push({ valid: false, label: item.label });
              if ((item.required == true) && (file == undefined))
                validList.push({ valid: false, label: item.label });
              var fileList = input.files;
              for (var s = 0; s < fileList.length; s++) {               
                var index=  fileList[s].name.lastIndexOf('.'); 
                var  filetype= fileList[s].name.substring(index+1)
                var exeFileExists = this.executableFileTypes.filter
                (e=>e.type.toLowerCase()===filetype.toString().toLowerCase());
               if(exeFileExists.length>0){
              validList.push({ valid: false, label: 'filetype' });
               validFileList.push({valid:false,label:'.'+exeFileExists[0].type+ ' files are not allowed.'})
               }
                formData.set(txt + '_' + s, fileList[s], fileList[s].name.replace(/[']/g, "''").replace(/[,]/g, "_"));
                //formData.set(txt + '_' + s, fileList[s]);
                // formData.set(txt + '_' + s, fileList[s], fileList[s].name);
                // formData.set(txt + '_' + s, fileList[s], fileList[s].name.replace(/[%<>/\:*?";|]/g, ''));
              }
            }
            else if (item.type == 'checkbox-group') {
              var value = this.getChkbox(item.name);
              var a = this.validateInputs(value);
              if ((item.required == true) && (a != 0))
                validList.push({ valid: false, label: item.label });
              if (a == 0) {
                if (value != null) {
                  var selected = [];
                  selected = this.getSelectedid(value);
                  if (item.masters == 'Masters') {
                    allocationvalidation[txt] = JSON.stringify(selected);
                    formData.set(txt, JSON.stringify(selected));
                  }
                  //  formData.set(txt, selected);
                  else {
                    var list = item.values;
                    list.forEach((item, index) => {
                      selected.forEach(a => {
                        if (a.selectedid == item.value) {
                          list[index]['selected'] = true;
                        }
                      });
                    });
                    //  formData.set(txt, list);
                    formData.set(txt, JSON.stringify(list));
                    allocationvalidation[txt] = JSON.stringify(list);
                  }
                }
              }
              else {
                formData.set(txt, null);
              }

            }
            else if (item.type == 'radio-group') {
              var value = this.getChkbox(item.name);
              var a = this.validateInputs(value);
              if ((item.required == true) && (a != 0))
                validList.push({ valid: false, label: item.label });
              if (a == 0) {
                if (value != null) {
                  var selected = [];
                  selected = this.getSelectedid(value);
                  if (item.masters == 'Masters')
                    formData.set(txt, JSON.stringify(selected));
                  // formData.set(txt, selected.toString());

                  else {
                    var list = item.values;
                    list.forEach((item, index) => {
                      selected.forEach(a => {
                        if (a.selectedid == item.value) {
                          list[index]['selected'] = true;
                        }
                      });
                    });
                    formData.set(txt, JSON.stringify(list));
                    // formData.set(txt, list);
                  }
                }
              }
              else {
                formData.set(txt, null);
              }

            }
            else if (item.type == 'select') {
              let selected: any = [];
              var a = 0;
              if ((item.multiple != true) || (item.multiple == undefined)) {
                a = $('#' + item.name)[0].selectedOptions[0].value;
                if ((item.required == true) && (a == 0))
                  validList.push({ valid: false, label: item.label });
                if (a != 0) {
                  selected = a;
                  if (item.masters == 'Masters') {
                    //       var _sel = '{"selectedid": '+ selected+' }';
                    var _sel = [];
                    _sel.push({ selectedid: selected })

                    formData.set(txt, JSON.stringify(_sel));
                    // formData.set(txt, _sel);
                  }

                  else {
                    var data = [];
                    var list = item.values;
                    list.forEach(item => {
                      if (item.value == selected) {
                        data.push({ label: item.label, value: item.value, selected: true });
                      }
                      else {
                        data.push({ label: item.label, value: item.value });
                      }
                    })
                    formData.set(txt, JSON.stringify(data));
                    // formData.set(txt, data.toString());
                  }
                }
                else {
                  formData.set(txt, null);
                }

              }
              if (item.multiple == true) {
                var b = $('#' + item.name)[0].selectedOptions;
                if ((item.required == true) && (b.length == 0))
                  validList.push({ valid: false, label: item.label });
                if (b.length != 0) {
                  for (var m = 0; m < b.length; m++) {
                    selected.push({ selectedid: b[m].value })
                  }
                  if (item.masters == 'Masters')
                    formData.set(txt, JSON.stringify(selected));
                  else {
                    var sel = [];
                    for (var m = 0; m < b.length; m++) {
                      sel.push({ selectedid: b[m].value, selectedvalue: b[m].text })
                    }

                    var data = [];
                    var list = item.values;
                    list.forEach((item, index) => {
                      sel.forEach(a => {
                        if ((a.selectedid == item.value) && (a.selectedvalue == item.label)) {
                          list[index]['selected'] = true;
                        }
                      });
                    });
                    formData.set(txt, JSON.stringify(list));
                    // formData.set(txt, list);
                  }

                }
                else {
                  formData.set(txt, null);
                }

              }
            }
            else {
              if (item.type != 'hidden' && item.type != 'header' && item.type != 'paragraph') {
                let e2 = document.getElementById(item.name);
                if (item.required == true) {
                  if ((<HTMLInputElement>e2).value == '') {
                    validList.push({ valid: false, label: item.label });
                  }
                }
                if (item.type == 'text' || item.type == 'textarea') {
                  if ((<HTMLInputElement>e2).value != '' && (<HTMLInputElement>e2).value != undefined && (<HTMLInputElement>e2).value != null)
                    formData.set(txt, (<HTMLInputElement>e2).value.replace(/'/g, "''"));
                }

                if (item.type == 'date') {
                  if ((<HTMLInputElement>e2).value != '' && (<HTMLInputElement>e2).value != undefined && (<HTMLInputElement>e2).value != null) {
                    formData.set(txt, (<HTMLInputElement>e2).value);
                  }
                  else {
                    if (this._action == 'update') {
                      formData.set(txt, null);
                    }
                  }
                }
                else
                  if (item.type != 'date') {
                    formData.set(txt, (<HTMLInputElement>e2).value);
                  }

              }
            }
          }
        });
      }

      if (validList.length == 0) {
        formData.set('dbid', this.formRenderForm.get('dbid').value);
        formData.set('formconfigid', this.formRenderForm.get('formconfigid').value);
        this.databaseId=this.formRenderForm.get('dbid').value;
        this.formConfigId=this.formRenderForm.get('formconfigid').value;
        var formconfigname = $("#formconfigid option:selected").text();
        //  formData.set('formconfigname', formconfigname);
        var dbname = $("#dbid option:selected").text();
        formData.set('dbname', dbname.trim());
        //this.userid = +localStorage.getItem('userid');
        this.userid = +this.localService.getJsonValue('userid');
        var table = '';
        var removeSpace = formconfigname.trim().split(/(\s+)/);
        if (removeSpace.length != 0) {
          removeSpace.forEach(a => {
            table = table + a.trim();
          });
        }
        formData.set('tablename', table.trim().toLowerCase());
        formData.set('active', '1');
        if (formconfigname.trim() == 'Opinions' && allocationvalidation != {}) {
          let chkallocation16 = allocationvalidation['chkallocation16'] == undefined ? [] : JSON.parse(allocationvalidation['chkallocation16']);
          let chkpublished17 = allocationvalidation['chkpublished17'] == undefined ? [] : JSON.parse(allocationvalidation['chkpublished17']);
          let chkreviewed18 = allocationvalidation['chkreviewed18'] == undefined ? [] : JSON.parse(allocationvalidation['chkreviewed18']);

          if (chkallocation16.length > 0 && (chkreviewed18.length == 0)) {
            this.SpinnerService.hide();
            this.submitted = false;
            $('#btnsumbit').prop('disabled', false);
            this.toastr.warning('Please select Reviewed');
            return;
          }
          if ((chkallocation16.length == 0 && chkreviewed18.length > 0) ) {
            this.SpinnerService.hide();
            this.submitted = false;
            $('#btnsumbit').prop('disabled', false);
            this.toastr.warning('Please select any allocation');
            return;
          }
        }

        if (this._action == 'add') {
          //formData.set('createdby', this.userid.toString());
          formData.set('createdby', this.localService.getJsonValue('userid'));
          this.formRenderService.Post(formData).subscribe( async res => {
            if (res.status == 200) {
              if (res != undefined) {
                if (res.body != 0) {
                  this.toastr.success('Data added successfully');
                  this.SpinnerService.hide();
                  if(isautologsubmit!=true){
                  this.router.navigate(['/home/formdashboard'], { queryParams: { 'db': this.enc.encryptUsingAES256(this.databaseId.toString()),//this.databaseId,
                   'formconfigid': isNaN(this.formConfigId) ? this.enc.encryptUsingAES256(0)  : this.enc.encryptUsingAES256(this.formConfigId.toString()) } });										   
                
                   if (this.createmode == true) {   
                    if(this.mode == 'newtab')
                    self.close();
                    else            
                   this.Backtoformlist();                  
                  }
                  this.clearForm();
                  $("#btnsumbit").removeAttr('disabled'); 
                }
                else{
                  
                  const queryString = window.location.href;
                  
        debugger     

//let shortenedUrl='';
this.shortenedUrl = await this.getTinyUrl(queryString,this.documentId,this.formConfigId,this.dbid);
/*
this.tinyUrl.shorten(queryString).subscribe(res => {
  debugger
  shortenedUrl = res;
  console.log(res); // https://tinyurl.com/8wa5w2o;
});*/
                  this.documentId=res.body;
                  let jsonObject = {
                    "ProductLine": formconfig.ProductLine,
                    "Product": formconfig.Product,
                    "Source":this.shortenedUrl,// queryString,
                    "DocumentId": this.documentId,
                    "FormconfigId": this.formConfigId
                  };
                  this.formRenderService.sendtoautologproduct(JSON.stringify(jsonObject)).subscribe(
                    (res) => {
                      
                      console.log(res);
                      this.autologURL = res.body[1].Url;
                      //window.open(this.autologURL, "_blank");
              
                      var form = document.createElement("form");
                      form.target = "_blank";
                      form.method = "POST";
                      form.action = this.autologURL+this.apitoken;
                      form.style.display = "none";
              
                      
                        var input = document.createElement("input");
                        input.type = "hidden";
                        input.name = "jsonData";
                        input.value = btoa(res.body[0].j);          
                        form.appendChild(input);                  
                       document.body.appendChild(form);
                      form.submit();
                      document.body.removeChild(form);             
                      this.clear();             
                      this.SpinnerService.hide();
                      this._action='update';
                  
                    },
            error => { 
              
              console.log(error);            
              $("#btnsumbit").removeAttr('disabled');
              this.toastr.error("Error while opening autolog");
              this.SpinnerService.hide();
            });
                }                 
                }
                else {
                  this.SpinnerService.hide();
                  this.toastr.warning('Record already exists.');
                }
                
              }
            };
          },
            error => {
              debugger
              console.log(error);
              if(error.error.message=='File name already exists')
              this.toastr.error(error.error.message);
              else
              this.toastr.error("Error while Adding the data");
              //  $("#btnsumbit").css('visibility', 'visible');
              $("#btnsumbit").removeAttr('disabled');
              
              this.SpinnerService.hide();
            });
        }
        else if (this._action == 'update') {
          //formData.set('modifiedby', this.userid.toString());
          formData.set('modifiedby', this.localService.getJsonValue('userid'));
          formData.set('documentid', this.documentId);
          // formData['documentid'] = ;
          this.formRenderService.Put(formData).subscribe(async res => {
            if (res.status == 200) {
              if (res != undefined) {
                if (res.body != 0) {
                  this.toastr.success('Data updated successfully');
                  this.SpinnerService.hide();
                  $("#btnsumbit").removeAttr('disabled');
                  if(isautologsubmit!=true){
                  this.router.navigate(['/home/formdashboard'], { queryParams: { 
                    'db': this.enc.encryptUsingAES256(this.databaseId.toString()),
                     'formconfigid': isNaN(this.formConfigId) ? this.enc.encryptUsingAES256(0) : this.enc.encryptUsingAES256(this.formConfigId.toString()) } });
           
                    
                     this.clearForm();
                  // $("#btnsumbit").css('visibility', 'visible');
                  if(this.mode == 'newtab')
                    self.close();
                    else 
                  this.Backtoformlist();
                }else{
                  const queryString = window.location.href;
               
                  //let shortenedUrl='';
                  this.shortenedUrl = await this.getTinyUrl(queryString,this.documentId,this.formConfigId,this.dbid);
                  let jsonObject = {
                    "ProductLine": formconfig.ProductLine,
                    "Product": formconfig.Product,
                    "Source": this.shortenedUrl,//queryString,
                    "DocumentId": this.documentId,
                    "FormconfigId": this.formConfigId
                  };
                  this.formRenderService.sendtoautologproduct(JSON.stringify(jsonObject)).subscribe(
                    (res) => {
                      console.log(res);
                      this.autologURL = res.body[1].Url;
                      //window.open(this.autologURL, "_blank");
              
                      var form = document.createElement("form");
                      form.target = "_blank";
                      form.method = "POST";
                      form.action = this.autologURL+this.apitoken;
                      form.style.display = "none";
              
                      
                        var input = document.createElement("input");
                        input.type = "hidden";
                        input.name = "jsonData";
                        input.value = btoa(res.body[0].j);
              
              
                        form.appendChild(input);
                      
              
                      document.body.appendChild(form);
                      form.submit();
                      document.body.removeChild(form);
              
                      this.clear();
              
                      this.SpinnerService.hide();
                    },
            error => {             
              $("#btnsumbit").removeAttr('disabled');
              this.toastr.error("Error while opening autolog");
              this.SpinnerService.hide();
            });
                  //this._sendToAutoLog=false;
                }
                }
                else {
                  this.toastr.warning('Record already exists.');
                  this.SpinnerService.hide();
                }

              
              }
            };
          },
            error => {
              //  $("#btnsumbit").css('visibility', 'visible');
              $("#btnsumbit").removeAttr('disabled');
              if(error.error.message=='File name already exists')
              this.toastr.error(error.error.message);
              else
              this.toastr.error("Error while Adding the data");
             // this.toastr.error("Error while Adding the data");
              this.SpinnerService.hide();
            });
        }
      }
      else {
        if(validList[0].label!='filetype'){
        var fieldLable = validList[0].label.replace
        this.toastr.error(validList[0].label + ' value is required');
        // $("#btnsumbit").css('visibility', 'visible');
        $("#btnsumbit").removeAttr('disabled');
        this.SpinnerService.hide();
        } else {
          this.toastr.error(validFileList[0].label);
          $("#btnsumbit").removeAttr('disabled');
          this.SpinnerService.hide();
        }
      }
    }
    else {
      this.toastr.error('Some of the values are not filled');
      // this.SpinnerService.hide();
    }

  }


 async generateandcopyURL(){
  const queryString = window.location.href;
               
  //let shortenedUrl='';
  this.shortenedUrl = await this.getTinyUrl(queryString,this.documentId,this.formConfigId,this.dbid);
  
   
          navigator.clipboard.writeText(this.shortenedUrl);
          this.toastr.success('URL generated and copied successfully');
      
   
   }

 async getTinyUrl(queryString,documentId,formConfigId,dbid){
  //var shortenurl = await this.tinyUrl.shorten(queryString).toPromise().then(res=>res);
  queryString=encodeURIComponent(queryString);
  var shortenurl= await this.formRenderService.getShortenURLDts(queryString).toPromise().then(res=>res);
  var ShortenURLDts =[];
  
  ShortenURLDts.push({documentid:documentId,formconfigid:formConfigId,database:dbid,shortenurl:shortenurl.tinyUrl,
    createdby:this.userid});
   
    var result ='';
 var _res= await this.formRenderService.createShortenURLDts(ShortenURLDts[0]).toPromise().then(res=>res.body);
 console.log(_res);
    if(_res!=undefined && _res!=null){
      result=_res[0].shortenurl
    }

 return result;
  };


  createDocument() {
    if (this._formConfigList.length != 0) {
      this._action = 'add';

      let queryParams = {};
      queryParams['db'] =this.enc.encryptUsingAES256(this.databaseId.toString());// this.databaseId;
      queryParams['formConfigId'] = this.enc.encryptUsingAES256(this.formConfigId.toString());//this.formConfigId;
      queryParams['mode'] =this.enc.encryptUsingAES256( 'add');// 'add';

      const navigationExtras: NavigationExtras = {
        queryParams,
        state: {
          db: this.databaseId,
          formDB: this.dbid,
          data: null,
          formConfigId: this.formConfigId,
          mode: null,
          page: this.pageInput,
          selectedgroup: this.selectedgroup,
          searchdata: this.searchdata,
          filterTable: this.filterTable,
          filterValue: this.filterValue,
          isCustomSearch: this.isCustomSearch,
          itemsPerPage: this.itemsPerTable,
          customSearchData: this.customSearchData,
          selectedNodeText: this.selectedNodeText,
          fromrender: 1,
          subPage: this.subPage,
          columnsearchname: this.columnsearchname,
          columnsearchgroup: this.columnsearchgroup,
          isSort: this.isSort,
          sortingconditionValue: this.sortingconditionValue,
          sortDirectionValue: this.sortDirectionValue,
          isSortGroupBy: this.isSortGroupBy,
          sortingconditionGroupBy: this.sortingconditionGroupBy,
          sortingDirectionGroupBy: this.sortingDirectionGroupBy,
          customSearchSortConditionValue: this.customSearchSortConditionValue,
          sortingconditionValueGroupBy: this.sortingconditionValueGroupBy,
          selectedNodeValue: this.selectedNodeValue
        }
      };
      this.router.navigate([], navigationExtras

        //{
        //queryParams: {
        //  data: null,
        //  mode: null,
        //},
        //queryParamsHandling: 'merge'
        //}
      )
      this.createmode = true;
      var s = this._formConfigList.filter(e => e.formconfigid == this.formConfigId);
      if ((s != undefined) && (s.length != 0)) {
        this.htmlData = s[0].htmldata;
        var arr = JSON.parse(s[0].htmldata);
        //get list of field alias name
        if (arr.length > 0) {
          arr.forEach(item => {
            if (item.name != undefined) {
              this.formRenderForm.addControl(item.name, new FormControl('', []));
            }
          });
        }
        var htmData = JSON.parse(s[0].htmldata)
        if (htmData.length > 0) {
          var tabledetails = htmData.filter(e => e.tablename != undefined && e.tablename != '' && e.tablename != null)
          var tableid = '';
          if (tabledetails.length != 0) {
            tabledetails.forEach(p => {
              var s = p.values.filter(e => e.selected == true)[0].value;
              if (s != undefined && s != null && s.length != 0) {
                if (tableid == '')
                  tableid = s;
                else
                  tableid = tableid + ',' + s;
              }
            })
          }
          if (tableid != '') {
            this.formRenderService.GetAllGivenMasterDetails(tableid).subscribe(res => {
              if (res != undefined && res != null) {
                this._allMasterList = [];
                this._allMasterList = res;
//this.formConfigIdInput = 0;
                //this.documentIdInput = 0;
                this.fileDownloadList = [];
                var cleanedData = this.validFormData(s[0].htmldata);
                this.loadhtmldata(cleanedData);
              }
            });
          }
          else {
            //this.formConfigIdInput = 0;
           // this.documentIdInput = 0;
            this.fileDownloadList = [];
            var cleanedData = this.validFormData(s[0].htmldata);
            this.loadhtmldata(cleanedData);
          }

          if (this.formConfigId == 194) {
            $('.form-group[class*="field-fileFullText"]').css('display', 'none');
            $('.form-group[class*="field-filefulltext"]').css('display', 'none');
          }
        }
      }
      else
        this.htmlData = '';
    }
  }

  removeFormDocument() {
    var formconfigname = this._formConfigListTmp.filter(e => e.formconfigid == this.formConfigId)[0].formconfigname;
    var _inputData = [];
    _inputData.push(
      {
        'formconfigid': this.formConfigId,
        'tablename': formconfigname.replace(' ', '').toLowerCase(),
        'documentid': this.documentId,// this.documentIdInput,
        'createdby': this.localService.getJsonValue('userid')
      })

    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to remove this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.formRenderService.Delete(_inputData[0]).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success("Record deactivated successfully");
                // this.router.navigate(['/home/formdashboard', { 'db': this.databaseId, 'formconfigid': this.formConfigId }]);
          
          if(this.mode == 'newtab')
          self.close();
          else          
               this.Backtoformlist();
               
               // this.eventEmitterService.onFirstComponentButtonClick();
              //  self.close();


               // this.router.navigate(['/home/formdashboard'], { queryParams: { 'db': this.databaseId, 'formconfigid': this.formConfigId } });
              }
            }, error => {
              this.toastr.error(error);
            });
        }
      });
  }

  getChkbox(checkboxname) {
    var selchbox = [];// array that will store the value of selected checkboxes
    // gets all the input tags in frm, and their number
    let inpfields = document.getElementsByTagName('input');
    var nr_inpfields = (<HTMLCollection>inpfields).length;
    // traverse the inpfields elements, and adds the value of selected (checked) checkbox in selchbox
    for (var i = 0; i < nr_inpfields; i++) {
      var name = inpfields[i].name.replace(/[^a-zA-Z0-9]/g, '');
      if (name == checkboxname) {
        var object = {};
        object["name"] = inpfields[i].value;
        object["value"] = inpfields[i].checked == true ? 1 : 0;
        selchbox.push(object);
      }

    }
    return selchbox;
  }

  loadFormConfig() {
    this.SpinnerService.show()
    this._formConfigList = [];
    this.formRenderService.getFormConfig().subscribe(res => {
      this._formConfigList = res;
      this._formConfigList.forEach(data => {
        if (data.active != 0) {
          this._formConfigListTmp.push({ formconfigid: data.formconfigid, formconfigname: data.formconfigname })
        }
      });
      this._formConfigListTmp = JSON.parse(JSON.stringify(this._formConfigListTmp));
      this._formConfigListTmp = this._formConfigList.filter(e => e.dbid == this.databaseId && e.active == 1);
      this.formRenderForm.controls['formconfigid'].setValue(0);
      if (this.mode == 'add' || this.mode == 'addByDashboard') {
        this.SpinnerService.hide();
      }
    }, error => { this.SpinnerService.hide();this.toastr.error('Error while getting the form Config  data'); })
  }

  loadFormRenderView() {
    // console.log(JSON.parse(this.documentData));
   
    this.SpinnerService.show();
    var productname = '';
    if(this.searchdata !=undefined && this.searchdata !='')
    {
      productname = this.searchdata;
    }

/*
if(this.countConditionObj!= undefined && this.countConditionObj!=''){
if(this.countConditionObj.fieldscondition !=undefined && this.countConditionObj.fieldscondition !=''){
var data=JSON.parse(this.countConditionObj.fieldscondition);
if(data.fieldscondition.length>0){
var  product = data.fieldscondition.filter(r=>r.label =='Allocation');
  if(product != undefined && product!=''){
    productname = product[0].value;
  }
}
}

}*/
    
    var documentStatus = [];

    documentStatus.push({
      'formconfigid': this.formConfigId,
      'documentid': this.documentId,
      'fromopenedfrom': productname,
      'createdby': this.userid
    });
    this.formRenderService.AddDocumentActivityLogview(documentStatus[0]).subscribe(res => {
      
    }, err => {
     
    });





    var _activeformconfigdetails = this.formConfigId + '*' + this.documentId + '*' + this.archiveyear;

    this.formRenderService.getFormRenderDocumentDetails(_activeformconfigdetails).subscribe(
      (res) => {
        if (res != undefined && res != null && res.length != 0 && (JSON.parse(res[0].j) != null)) {
          this.autolog = (JSON.parse(res[0].j));
          this._formConfigList = [];
          this.formRenderService.getFormConfig().subscribe(res => {
            this._formConfigList = res;
            
            this._formConfigList.forEach(data => {

              if (data.active != 0) {
                this._formConfigListTmp.push({ formconfigid: data.formconfigid, formconfigname: data.formconfigname })
              }
            });
            this._formConfigListTmp = JSON.parse(JSON.stringify(this._formConfigListTmp));
            this._formConfigListTmp = this._formConfigList.filter(e => e.dbid == this.databaseId && e.active == 1);
            if (this.formConfigId != 0) {
              this.formRenderForm.controls['formconfigid'].setValue(this.formConfigId);
              if (this._formConfigList.length != 0) {
                var s = this._formConfigList.filter(e => e.formconfigid == this.formConfigId);
                if ((s != undefined) && (s.length != 0)) {
                  var arr = JSON.parse(s[0].htmldata);
                  //get list of field alias name
                  if (arr.length > 0) {
                    arr.forEach(item => {
                      if (item.name != undefined) {
                        this.formRenderForm.addControl(item.name, new FormControl('', []));
                      }
                    });
                  }
                  var _formconfigdetails = this.formConfigId + '*' + this.documentId + '*' + this.archiveyear;
                  var htmData = JSON.parse(s[0].htmldata)
                  if (htmData.length > 0) {
                    var tabledetails = htmData.filter(e => e.tablename != undefined && e.tablename != '' && e.tablename != null)
                    var tableid = '';
                    if (tabledetails.length != 0) {
                      tabledetails.forEach(p => {
                        var s = p.values.filter(e => e.selected == true)[0].value;
                        if (s != undefined && s != null && s.length != 0) {
                          if (tableid == '')
                            tableid = s;
                          else
                            tableid = tableid + ',' + s;
                        }
                      })
                    }
                    if (tableid != '') {
                      this.formRenderService.GetAllGivenMasterDetails(tableid).subscribe(res => {
                        if (res != undefined && res != null) {
                          this._allMasterList = [];
                          this._allMasterList = res;
                          //get the form document details
                          this.formRenderService.getFormRenderDocumentDetails(_formconfigdetails).subscribe(
                            (res) => {
                              if (res != undefined && res != null && res.length != 0) {
                                var _formDocumentData = JSON.parse(res[0].j);
                                if (_formDocumentData.length != 0) {
                                  this.formDetailsList = _formDocumentData;
                                  var cleanedData = this.validFormData(s[0].htmldata);
                                  this.LoadUserAssignedValue(cleanedData, this.formDetailsList);

                                  //this.SpinnerService.hide();
                                }
                              }
                            });
                        }
                      });
                    }
                    else {
                      //get the form document details
                      this.formRenderService.getFormRenderDocumentDetails(_formconfigdetails).subscribe(
                        (res) => {
                          if (res != undefined && res != null && res.length != 0) {
                            var _formDocumentData = JSON.parse(res[0].j);
                            if (_formDocumentData.length != 0) {
                              this.formDetailsList = _formDocumentData;
                              var cleanedData = this.validFormData(s[0].htmldata);
                              this.LoadUserAssignedValue(cleanedData, this.formDetailsList);

                              //this.SpinnerService.hide();
                            }
                          }
                        });
                    }
                  }
                }
              }
            }
            //else
            //  this.formRenderForm.controls['formconfigid'].setValue(0);

          }, error => { this.SpinnerService.hide();this.toastr.error('Error while getting the form Config  data'); });
        }


        else {
          this.SpinnerService.hide();
          this.toastr.error('Document does not exists');
          //this.router.navigate(['/home/formdashboard', {
          //  'db': this.databaseId, 'formconfigid': this.formConfigId, 'page': 1
          //}]);
          this.Backtoformlist();
        }
      });
  }

   LoadUserAssignedValue(data, item) {
    this.SpinnerService.show();
     this.formRenderService.getStatenetFulltextDatabaseId().subscribe(async (result) => {
       this.fileDownloadList = [];
      if (result != undefined && result != null)
        this.statenetFulltextDatabaseId = result;
      else
        this.statenetFulltextDatabaseId = 0;
      this.formRenderForm.controls['formconfigid'].setValue(this.formConfigId);
      var formData = JSON.parse(data);
      var d = item;
		this.viewuserdetails=d[0].vieweduserdetails== null ? [] : d[0].vieweduserdetails;				  
      this.requestDetails = d[0].requestdetails == null ? [] : d[0].requestdetails;
      // added for noncase law

       let selectedDb = this._databaseList.filter(x => this.formRenderForm.value.dbid == x.databaseid);
       if (selectedDb[0].database == 'Non Case Law') {
         let fulltextfilename = '';
         let txtareafulltext = '';
         // tslint:disable-next-line: forin
         for (var prop in d[0]) {
           if (prop.toLowerCase().trim().includes('txtfulltextfilename')) {
             fulltextfilename = prop;
           }
           if (prop.toLowerCase().trim().includes('txtareafulltext')) {
             txtareafulltext = prop;
           }
         }
         if (d[0][fulltextfilename] != '' && d[0][fulltextfilename] != null) {
           let html = await this.formRenderService.GetNonCaseLawFile(d[0][fulltextfilename], selectedDb[0].database, this.formConfigId.toString(), this.documentId.toString()).toPromise().then((result: any) => { return result });
           d[0][txtareafulltext] = html.htmlString;

           this.fileDownloadList.push(
             {
               filename: d[0][fulltextfilename],
               documentId: this.documentId,
               formConfigId: this.formConfigId,
               filesize: '' //(fSize == undefined) ? ' ' : ((Math.round(fSize * 100) / 100) + ' ' + fSExt[i])
             });

         } else {
           d[0][txtareafulltext] = '';
         }
       }


      //end of noncaselaw code
      if (d.length != 0 && d != undefined) {
        formData.forEach(a => {
          if (a.type != 'hidden' && a.name != 'issendnotification') {
            if (d[0][a.formcontrolname.toLowerCase()] != null && d[0][a.formcontrolname.toLowerCase()] != undefined) {
              if (a.formcontrolname.toLowerCase() != '' && a.formcontrolname.toLowerCase() != undefined) {
                if ((a.type == 'select') || (a.type == 'checkbox-group') || (a.type == 'radio-group')) {
                  if (a.masters == 'Masters') {
                    var selectedValues = d[0][a.formcontrolname.toLowerCase()];
                    if (selectedValues.length != 0) {
                      if (selectedValues[0].selectedid != null && selectedValues[0].selectedid != undefined) {
                        for (var i = 0; i < selectedValues.length; i++) {
                          a.values.forEach((b, ind) => {
                            if (b.value == selectedValues[i].selectedid) {
                              a.values[ind]['selected'] = true;
                            }
                          });
                        }
                      } else {
                        var _dataValues = a.values;
                        _dataValues.forEach((item, index) => {
                          if (item.value == selectedValues) {
                            _dataValues[index]['selected'] = true;
                          }
                        });
                        a.values = _dataValues;
                      }
                    }
                  }

                  else {
                    a.values = d[0][a.formcontrolname.toLowerCase()];
                  }
                }
                else if (a.type == 'file') {
                  
                  if (d[0][a.formcontrolname.toLowerCase()] != null && d[0][a.formcontrolname.toLowerCase()] != '' && 
                  d[0][a.formcontrolname.toLowerCase()] != undefined)
                    a.label = a.label + '  (' + d[0][a.formcontrolname.toLowerCase()].replace(';', ',') + ')';
                  //  console.log(d[0][a.formcontrolname.toLowerCase()].split('*'));
                  var s = d[0][a.formcontrolname.toLowerCase()].split(';');
                  var fileSizeFieldName = a.formcontrolname + 'size';
                  let fileSize: any;
                  if (d[0][fileSizeFieldName.toLowerCase()] != null)
                    fileSize = d[0][fileSizeFieldName.toLowerCase()].split(';');
                  else
                    fileSize = 0;
                  if (s != undefined && s.length != 0) {
                    for (var n = 0; n < s.length; n++) {
                      //var fSExt = new Array('Bytes', 'KB', 'MB', 'GB');
                      //var fSize = fileSize[n]; i = 0; while (fSize > 900) { fSize /= 1024; i++; }

                      this.fileDownloadList.push(
                        {
                          filename: s[n],
                          documentId: this.documentId,
                          formConfigId: this.formConfigId,
                          filesize: fileSize[n] //(fSize == undefined) ? ' ' : ((Math.round(fSize * 100) / 100) + ' ' + fSExt[i])
                        });
                    }
                  }
                }
                else if (a.type == 'date') //T00:00:00
                {
                  var s = d[0][a.formcontrolname.toLowerCase()].split('T');
                  if (s.length != 0) {
                    a["value"] = s[0];
                  }
                  //  a["value"] = d[0][a.formcontrolname.toLowerCase()].replace('T00:00:00', '');
                }

                else if (((a.label == 'Full Text' && a.type == 'textarea') || (a.label == 'Session') || (a.label == 'Cite') || (a.label == 'Bill No')) && this.statenetFulltextDatabaseId == +this.databaseId) {
                  a["readonly"] = "true";
                  if (d[0][a.formcontrolname.toLowerCase()] != undefined)
                    a["value"] = d[0][a.formcontrolname.toLowerCase()]
                  else
                    a["value"] = '';
                }
                else {
                  if (d[0][a.formcontrolname.toLowerCase()] != undefined)
                    a["value"] = d[0][a.formcontrolname.toLowerCase()]
                  else
                    a["value"] = '';
                }

                if (a.type == 'text' || a.type == 'textarea') {
                  a["value"] = d[0][a.formcontrolname.toLowerCase()].replace(/''/g, "'");
                }
              }
            }
          }
          if(a.label=='XML Filename' && a.type == 'hidden'&&  a.name != 'issendnotification'){
            
            if (d[0][a.formcontrolname.toLowerCase()] != null && d[0][a.formcontrolname.toLowerCase()] != '' && 
            d[0][a.formcontrolname.toLowerCase()] != undefined){
              a.label = a.label + '  (' + d[0][a.formcontrolname.toLowerCase()].replace(';', ',') + ')';
            //  console.log(d[0][a.formcontrolname.toLowerCase()].split('*'));
            var s = d[0][a.formcontrolname.toLowerCase()].split(';');
            var fileSizeFieldName = a.formcontrolname + 'size';
            let fileSize: any;
            if (d[0][fileSizeFieldName.toLowerCase()] != null)
              fileSize = d[0][fileSizeFieldName.toLowerCase()].split(';');
            else
              fileSize = 0;
            if (s != undefined && s.length != 0) {
              for (var n = 0; n < s.length; n++) {
                this.fileDownloadList.push(
                  {
                    filename: s[n],
                    documentId: this.documentId,
                    formConfigId: this.formConfigId,
                    filesize: fileSize[n] 
                  });
              }
            }
          }
          }
        });
      }
      var documentStatus = [];
      documentStatus.push({
        'formconfigid': this.formConfigId,
        'documentid': +this.documentId,
        'readstatus': 1,
        'createdby': this.userid
      });
      this.formdashboardservice.insertDocumentStatus(documentStatus[0]).subscribe(res => {
        if (res != undefined) {
         // if (res.body != 0) {
            this.loadhtmldata(JSON.stringify(formData));
            if (this.formConfigId == 194) {
              $('.form-group[class*="field-fileFullText"]').css('display', 'none');
              $('.form-group[class*="field-filefulltext"]').css('display', 'none');
			  $('.form-group[class*="field-txtBillNo"]').addClass('width_increase');
              $('.form-group[class*="field-txtSession"]').addClass('width_increase');
              $('.form-group[class*="field-txtCite"]').addClass('width_increase');
              $('.form-group[class*="field-txtareaFullText"]').addClass('move_mtop');
            }
         // }
        }
      })
      this.formProfileList = [];
      if (this.statenetFulltextDatabaseId != +this.databaseId) {
        var _activeformconfigdetails = this.formConfigId + '*' + this.documentId + '*' + this.archiveyear;
        this.formRenderService.getSelectedDocumentFormProfilesDetails(_activeformconfigdetails).subscribe(res => {
          if (res != undefined && res != null && res.length != 0 && (JSON.parse(res[0].j) != null)) {
            var profileData = JSON.parse(res[0].j);
            console.log(profileData);
            this.formProfileList = [];
            if (profileData.length != 0) {
              this.formProfileList = profileData;
            }
          }
          else {
            this.formProfileList = [];
          }
        });
      }
    });
    this.SpinnerService.hide();
  }

  //fileDownload(filename) {
  //  //  console.log(this.databaseId);
  //  var s = this._databaseList.filter(e => e.databaseid == this.databaseId)
  //  if (s != undefined && s != null && s.length != 0) {
  //    this.requestConfigService.DownloadFile(this.documentId, s[0].database, this.formConfigId, filename).subscribe(res => {
  //      var content = res.file;
  //      let objectURL = 'data:application/octet-stream;base64,' + res.file;
  //      saveAs(objectURL, filename);
  //    });
  //  }
  //}
  fileDownload(filename) {
    this.SpinnerService.show();
    filename = filename.trim();
    var s = this._databaseList.filter(e => e.databaseid == this.databaseId)
    if (s != undefined && s != null && s.length != 0) {

      let fileData: any = [];
      fileData.push({
        'documentId': this.documentId, 'dbName': s[0].database, 'formConfigId': this.formConfigId, 'fileName': filename
      })

   

      this.requestConfigService.DownloadFormFile(fileData[0]).subscribe(res => {

        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, filename);
        this.SpinnerService.hide();
      },
        error => {
          if (error.error == 'user loggedin')
            this.toastr.info('User Still loggined and working on the same file')
          else
            this.toastr.error('File not found');

          this.SpinnerService.hide();
        });


    }
  }

  viewfile(filename) {
    this.SpinnerService.show();
    filename = filename.trim();
    var s = this._databaseList.filter(e => e.databaseid == this.databaseId)
    if (s != undefined && s != null && s.length != 0) {

      let fileData: any = [];
      fileData.push({
        'documentId': this.documentId, 'dbName': s[0].database, 'formConfigId': this.formConfigId, 'fileName': filename
      })

       var ext = filename.substr(filename.lastIndexOf('.') + 1);

      
      
      this.requestConfigService.DownloadFormFiletabopen(fileData[0]).subscribe(res => {

        var content = res;
        if (ext.toLowerCase() == 'pdf' || ext.toLowerCase() == 'html'|| ext.toLowerCase() == 'txt'|| ext.toLowerCase() == 'xml') {
          let fileURL = URL.createObjectURL(content);
          window.open(fileURL);
        }
        
        this.SpinnerService.hide();
      },
        error => {
          if (error.error == 'user loggedin')
            this.toastr.info('User Still loggined and working on the same file')
          else
            this.toastr.error('File not found');

          this.SpinnerService.hide();
        });


    }
  }
  allfileDownload() {

    this.SpinnerService.show();    
    let fileData: any = [];
    var s = this._databaseList.filter(e => e.databaseid == this.databaseId);
    var filename = '';
    this.fileDownloadList.forEach((file) => {
      // foreach statement
      if (filename == '')
        filename = file.filename;
      else
        filename = file.filename + ',' + file;

    })  
    
      fileData.push({
        'documentId': this.documentId, 'dbName': s[0].database, 'formConfigId': this.formConfigId, 'fileName': filename
      });
    this.requestConfigService.DownloadFormFileAsZip(fileData[0]).subscribe(res => {
      var content = res.body.file;
      let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
      saveAs(objectURL, s[0].database+'_'+this.documentId + '.zip');
      this.SpinnerService.hide();
    },
      error => {
        if (error.error == 'user loggedin')
          this.toastr.info('User Still loggined and working on the same file')
        else
          this.toastr.error('File not found');

        this.SpinnerService.hide();
      });
    
  }

  showRequestConfig() {
    var formconfigname = this._formConfigListTmp.filter(e => e.formconfigid == this.formConfigId)[0].formconfigname;
    // this.router.navigate(['/home/requestconfig'],
    //   {
    //     queryParams: {
    //       'db': this.databaseId, 'documentId': this.documentId, 'formConfigId': this.formConfigId, 'requesttypeid': 5
    //       , 'formName': formconfigname //this.formConfigIdInput
    //     }
    //   });
    //let a= new encryptdecrypt();   
    let queryParams = {
      'db':  this.enc.encryptUsingAES256(this.databaseId.toString()),//this.databaseId,
      'documentId':  this.enc.encryptUsingAES256(this.documentId.toString()),//this.documentId,
      'formConfigId':this.enc.encryptUsingAES256(this.formConfigId.toString()),//this.formConfigId,
      'requesttypeid': this.enc.encryptUsingAES256(5),//5,
      'formName':this.enc.encryptUsingAES256(formconfigname.toString()),// formconfigname //this.formConfigIdInput
    };
    let url = this.router.createUrlTree(['/home/requestconfig'], { queryParams: queryParams });
    window.open('#' + url.toString(), '_blank');
  }
  openFormRenderLink(item) {
    var dbData = item.database.split('*');
    let url = this.router.createUrlTree(['/home/formrender'],
      { queryParams: { 'db':this.enc.encryptUsingAES256(dbData[0].toString()),//dbData[0],
       'formDB': this.enc.encryptUsingAES256(item.database.toString()),//item.database, 
       'data': this.enc.encryptUsingAES256(item.documentid.toString()),//item.documentid,
        'formConfigId': this.enc.encryptUsingAES256(item.formconfigid.toString()),//item.formconfigid, 
        'mode': this.enc.encryptUsingAES256('View')//'View' 
      } });
    window.open('#' + url.toString(), '_blank')
  }
  //openFormRenderLink(item) {


  //  var formdashboardUrl= '/home/formrender';
  //  let appurl = environment.appUrl;
  //  var dbData = item.database.split('*');
  //  let url = this.router.createUrlTree([formdashboardUrl],
  //    { queryParams: { 'db': dbData[0], 'formDB': item.database, 'data': item.documentid, 'formConfigId': item.formconfigid, 'mode': 'View' } });
  //  //window.open('#' + url.toString(), '_blank')
  //  window.open(appurl + url.toString(), '_blank')
  //  // window.open( url.toString(), '_blank')
  //}
  nextDocument() {
    let docid = '';
    this.SpinnerService.show();
    if (this.team != undefined && this.team != "" && this.team != "All"
    && (this.team == 'teamallocation' || this.team == 'teamallocationreview' ||
    this.team == 'teamallocationnotreview')) {
      let index = this.unreaddocumentids.findIndex(x => x["ACRN Doc ID"] == this.documentId);
      if (index != -1) {
        this.unreaddocumentids.splice(index, 1);
      }
    }else{
      let index = this.unreaddocumentids.findIndex(x => x == this.documentId);
      if (index != -1) {
        this.unreaddocumentids.splice(index, 1);
      }
    }
    if (this.unreaddocumentids.length == 0) {
      return false;
    } else {
      let ids = [];
      this.unreaddocumentids.forEach(element => {
        if (element < this.documentId) {
          ids.push(element);
        }
      });
     // let idsList = ids.sort((a, b) => a - b);

      this.unreaddocumentids.forEach(element => {
        if (element > this.documentId) {
          ids.push(element);
        }
      });

      docid = ids.length > 0 ? ids[0] : this.unreaddocumentids[0];
    }


    let queryParams = {};
 
    queryParams['db'] =this.enc.encryptUsingAES256(this.databaseId.toString()) ;//this.databaseId;
    queryParams['formDB'] = this.enc.encryptUsingAES256(this.dbid.toString()); //this.dbid;
    queryParams['data'] =this.enc.encryptUsingAES256(docid.toString()); // docid;
    queryParams['formConfigId'] = this.enc.encryptUsingAES256(this.formConfigId.toString());//this.formConfigId;
    queryParams['mode'] = this.enc.encryptUsingAES256('View');//'View';

    const navigationExtras: NavigationExtras = {
      queryParams,

      state: {
        db: this.databaseId,
        formDB: this.dbid,
        data: docid,
        formConfigId: this.formConfigId,
        mode: 'View',
        page: this.pageInput,
        selectedgroup: this.selectedgroup,
        searchdata: this.searchdata,
        filterTable: this.filterTable,
        filterValue: this.filterValue,
        isCustomSearch: this.isCustomSearch,
        itemsPerPage: this.itemsPerTable,
        customSearchData: this.isCustomSearch ? this.customSearchData : '',
        selectedNodeText: this.selectedNodeText,
        subPage: this.subPage,
        columnsearchname: this.columnsearchname,
        columnsearchgroup: this.columnsearchgroup,
        isSort: this.isSort,
        sortingconditionValue: this.sortingconditionValue,
        sortDirectionValue: this.sortDirectionValue,
        customSearchSortConditionValue: this.customSearchSortConditionValue,
        selectedNodeValue: this.selectedNodeValue
      }
    };
    this.SpinnerService.hide();
    this.router.navigate(['/home/formrender'], navigationExtras);
    this.ngOnInit();
  }

  getUserid(username) {
    var userid = '';
    if ((this.UserList != undefined) && (this.UserList.length != 0)) {
      var s = this.UserList.filter(e => (e.lastname + ", " + e.firstname + '(' + e.emailid + ')') == username);
      if ((s != undefined) && (s.length != 0)) {
        userid = s[0].userid;
      }
    }
    return userid;
  }
  loadformdashboarddetails() {
     //this.SpinnerService.show();
    let _documentList: any = [];
    let by = 'All';
    let totalformdetailcount = 0;
    let input: any = [];
    let rowsData = [];
    // console.log(this.selectedgroup);
    // console.log(this.searchdata);
    let _groupby = false;
    let searchbyfielname ='';
    let searchcountcondition='';
    let searchcondition='';
 
    if(this.selectedgroup != undefined && this.selectedgroup!=null && this.selectedgroup!=''&&
    this.searchdata != undefined && this.searchdata!=null && this.searchdata!='') {
      _groupby=true;  
      if (this.selectedgroup == "createdon") {
        searchcountcondition = " and cast(createdon as date)='" + this.searchdata.replace(new RegExp('/', 'g'), '-') + "'";
        searchcondition = " and cast(createdon as date)='" + this.searchdata.replace(new RegExp('/', 'g'), '-') + "'";
       
      }
      else if (this.selectedgroup == "createdby") {
       searchcountcondition = " and createdby=" + this.getUserid(this.searchdata);
        searchcondition = " and createdby=" + this.getUserid(this.searchdata);
       
      }
  
      else {
      
        searchcondition = " and " + this.selectedgroup.trim() + "='" + this.searchdata + "'";
        searchcountcondition = " and " + this.selectedgroup.trim() + "='" + this.searchdata + "'";
              
      }
    }

    
  if (this.team != undefined && this.team != "" && this.team != "All"
  && (this.team == 'teamallocation' || this.team == 'teamallocationreview' ||
  this.team == 'teamallocationnotreview')) {
    _groupby=true;
    searchcountcondition=this.team;
    searchcondition=this.team;

  }
    if(_groupby==false){
    input.push({
      'formconfigid': this.formConfigId,
      'searchcondition': 'All',
      'sorting': null,
      'groupleveldata': '',
    });
  }
   else{

    input.push({
      'formconfigid': this.formConfigId, 
      'searchcondition': searchcountcondition,
      'sorting': null, 
      'groupleveldata': ''      
    });
  
   }
    
    let countconditon = this.countConditionObj == null || this.countConditionObj == undefined ? input[0] : this.countConditionObj;
    let countservice: any;
    if (this.isadvancesearch) {
      countservice = this.formdashboardservice.getformadvancedsearchdetailscount(countconditon);
    } else {
      countservice = this.formdashboardservice.getAllFormDocumentDetailscount(countconditon);
    }
    countservice.subscribe((res) => {
  
      if (this.isadvancesearch) {
        totalformdetailcount = JSON.parse(res.body[0].formdetails)[0].count;
      } else {
        totalformdetailcount = res.body.count;
      }

      if (totalformdetailcount > 0) {
        let obj: any = [];
        if(_groupby==false){
        obj.push({
          'formconfigid': this.formConfigId,
          'pageno': this.pageInput,
          'itemsperpage': this.itemsPerTable,
          'searchcondition': 'All',
          'userid': this.userid,
          'sorting': null,
          'groupleveldata': ''
        });}
        else
        {          
          obj.push({
            'formconfigid': this.formConfigId, 
            'pageno': this.subPage, 
            'itemsperpage': this.itemsPerPagesub, 
            'searchcondition': searchcondition,
             'userid': this.userid,
             'sorting': null,
             'groupleveldata': ''
          })
        }
        let getconditon = this.getvaluesConditionObj == null || this.getvaluesConditionObj == undefined ? obj[0] : this.getvaluesConditionObj;
        let getservice: any;
        if (this.isadvancesearch) {
          getservice = this.formdashboardservice.getformadvancedsearchdetails(getconditon);
        } else {
          getservice = this.formdashboardservice.getAllFormDocumentDetails(getconditon);
        }

        getservice.subscribe(async (res) => {
          // console.log(res);
          if (res != undefined && res != null && res.length != 0) {
            let rowsData = [];
            if (this.isadvancesearch) {
              _documentList = JSON.parse(res.body[0].formdetails);
            } else {
              _documentList = JSON.parse(res.body[0].j);
            }

            if (_documentList != undefined && _documentList != null && _documentList.length != 0) {
              var list = _documentList;
              rowsData = list;
              let documentids = [];
              if (this.team != undefined && this.team != "" && this.team != "All"
              && (this.team == 'teamallocation' || this.team == 'teamallocationreview' ||
              this.team == 'teamallocationnotreview')) {
                rowsData.forEach(element => {
                  if (!element.read && element["ACRN Doc ID"] != this.documentId) {
                    documentids.push(element["ACRN Doc ID"]);
                  }
                });
              }
              else{
              rowsData.forEach(element => {
                if (!element.read && element.documentid != this.documentId) {
                  documentids.push(element.documentid);
                }
              });}
             // this.SpinnerService.hide();
              this.unreaddocumentids = [];
              this.unreaddocumentids = documentids.sort((a, b) => b - a);
            }
            else {
              this.unreaddocumentids = [];
             // this.SpinnerService.hide();
            }

          }
          else {
            this.unreaddocumentids = [];
           // this.SpinnerService.hide();
          }

        },
          err => {
            this.toastr.error('Not able to get dashboard data');
            this.SpinnerService.hide();
            this.unreaddocumentids = [];
          });
      }
      else {
        //this.SpinnerService.hide();
        this.unreaddocumentids = [];
      }
    });

  }

  viewrequest(request) {
    // let a = request.requestid + '*' + request.requesttypeid
    // this.router.navigate(['/home/requestconfig'], { queryParams: { requestid: request.requestid, requesttypeid: request.requesttypeid, redirectmode: 'viewrequest' } })
    let a = request.requestid + '*' + request.requesttypeid;
    let queryParams = {};
    queryParams['requestid'] = this.enc.encryptUsingAES256(request.requestid.toString());//request.requestid;
    queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttypeid.toString());//request.requesttypeid;
    queryParams['redirectmode'] = this.enc.encryptUsingAES256('viewrequest');//'viewrequest';
    let url = this.router.createUrlTree(['/home/requestconfig'], { queryParams: queryParams });
    window.open('#' + url.toString(), '_blank');

  }
  ActivityLog() {
  
    this.SpinnerService.show();
    this.viewlogdetails = [];
    this.logList = [];
    this.formRenderService.getDocumentActivityLog(this.formConfigIdInput1, this.documentIdInput1).subscribe(res => {
      //console.log(res);
    
      if (res != undefined)
		   res.forEach(data => {
        if(data.status==='Document Viewed'){
          this.viewlogdetails.push({
            'createdby':data.createdby,  
            'createdon':data.createdon,  
            'firstname':data.firstname , 
            'requestdetailid':data.requestdetailid,  
            'requesttype':data.requesttype,  
            'requesttypeid':data.requesttypeid,  
            'status':data.formopenedfrom == '' ?  data.status :  data.status +'(opened from '+ data.formopenedfrom +')',  
            'userid':data.userid,  
            'wkreviewflag':data.wkreviewflag  
          })
        }else{
          this.logList.push({
            'createdby':data.createdby,  
            'createdon':data.createdon,  
            'firstname':data.firstname , 
            'requestdetailid':data.requestdetailid,  
            'requesttype':data.requesttype,  
            'requesttypeid':data.requesttypeid,  
            'status':data.status,  
            'userid':data.userid,  
            'wkreviewflag': data.wkreviewflag   
          })
        }
      })
				   
     // this.logList = res;
      this.SpinnerService.hide();
    },

     
  err => {
  
  this.SpinnerService.hide();
  
});

    

  }

  fileDownloadrequest(request, fileName, type) {
    this.SpinnerService.show();
    // var s = this.databases.filter(e => e.databaseid == request.dbid)
    // if (s != undefined && s != null && s.length != 0) {
    var requesttype = '';
    if (request.requesttypeid == 1)
      requesttype = 'courtagoopinionrequest';
    if (request.requesttypeid == 2)
      requesttype = 'researchgrouprequest';
    if (request.requesttypeid == 3)
      requesttype = 'informationrequest';
    if (request.requesttypeid == 4)
      requesttype = 'internetdownloadrequest';
    if (request.requesttypeid == 5)
      requesttype = 'conversionrequest';

    let requestData: any = [];
    requestData.push({
      'requesttype': requesttype, 'dbname': request.dbname, 'requestid': request.requestid, 'fileName': fileName, 'type': type
    });

    request.finalupload = request.finalupload == null ? '' : request.finalupload;
    request.finaluploadsupportingfiles = request.finaluploadsupportingfiles == null ? '' : request.finaluploadsupportingfiles;

    let a = request.finalupload.split(/(?<=\.[a-z]+):/g);
    let b = request.finaluploadsupportingfiles.split(/(?<=\.[a-z]+):/g);

    if (a.length > 1 || b.length > 1) {
      if (type == 'finaloutput')
        requestData[0].fileName = requesttype + '_' + request.requestid;
      else {
        if (b.length > 1)
          requestData[0].fileName = requesttype + 'finalsupporting' + '_' + request.requestid;
      }

      // requestData[0].fileName = requesttype + '_' + request.requestid;

      fileName = requestData[0].fileName;
      this.requestConfigService.DownloadFileRequestWithSpecialCharactersasZIP(requestData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, fileName + '.zip');
        this.SpinnerService.hide();
      },
        error => {
          this.toastr.error('File not found');
          this.SpinnerService.hide();
        });

    } else {
      this.requestConfigService.DownloadFileRequestWithSpecialCharacters(requestData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, fileName);
        this.SpinnerService.hide();
      },
        error => {
          this.toastr.error('File not found');
          this.SpinnerService.hide();
        });
    }
  }

  public onContextMenu($event: KeyboardEvent, item: any): void {
    this.contextMenuService.show.next({
      anchorElement: $event.target,
      // Optional - if unspecified, all context menu components will open
      // contextMenu: this.contextMenu,
      event: <any>$event,
      item: item,
    });
    $event.preventDefault();
    $event.stopPropagation();
  }

   SubmitAutolog(frmConfig) {
   // const queryString = window.location.href;
    if (frmConfig.ProductLine === '') {
      this.toastr.error("ProductLine Should Not be Empty");
      return;
    }
    if (this.productItems.length === '0') {
      this.toastr.error("Product Should Not be Empty");
      return;
    }

 this.postFormRender(this.formRenderForm,frmConfig,true);

//this._sendToAutoLog=false;

    /*let jsonObject = {
      "ProductLine": frmConfig.ProductLine,
      "Product": frmConfig.Product,
      "Source": queryString,
      "DocumentId": this.documentId,
      "FormconfigId": this.formConfigId
    };
    this.formRenderService.sendtoautologproduct(JSON.stringify(jsonObject)).subscribe(
      (res) => {
        console.log(res);
        this.autologURL = res.body[1].Url;
        //window.open(this.autologURL, "_blank");

        var form = document.createElement("form");
        form.target = "_blank";
        form.method = "POST";
        form.action = this.autologURL+this.apitoken;
        form.style.display = "none";

        
          var input = document.createElement("input");
          input.type = "hidden";
          input.name = "jsonData";
          input.value = btoa(res.body[0].j);


          form.appendChild(input);
        

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);

        this.clear();


      })*/
  }

  sendtoautolog(mailgrpPopup: TemplateRef<any>, frmConfig){  

   console.log(this.userList);
   //this.productline
   let loggedUser=this.localService.getJsonValue("userid"); 
   let isLoggedUsrAutLog= +this.localService.getJsonValue("isautologuseronly");
   var loggedAutologUser=  this.userList.find(y => y.userid == loggedUser);


   if(loggedAutologUser.autologinputstr !=undefined && loggedAutologUser.autologinputstr!=''){
    var prdLineList=  JSON.parse(loggedAutologUser.autologinputstr);
    this.productline=[];
    this.productline=prdLineList.map(i=>({ProductLineID:i.productlineid,Name:i.name}));
   }
   else{
    this.productline=[];
   }
  /* if(isLoggedUsrAutLog!=0 && loggedAutologUser.isautologadmin!=1
    && loggedAutologUser.autologinputstr !=undefined && loggedAutologUser.autologinputstr!=''){
     var prdLineList=  JSON.parse(loggedAutologUser.autologinputstr);
     //var isPrdLineAdminLst= prdLineList.filter(y=>y.role=='Admin');
     this.productline=[];
     this.productline=prdLineList.map(i=>({ProductLineID:i.productlineid,Name:i.name})); 
    // if(isPrdLineAdminLst!=undefined && isPrdLineAdminLst.length>0)
    // {
     //  this.productline=isPrdLineAdminLst.map(i=>({ProductLineID:i.productlineid,Name:i.name})); 
    // }   
   } */


    this.formModalRef = this.bsModelService.show(mailgrpPopup, this.config);
    this.productItems = '';
    this.formConfigForm.controls['ProductLine'].setValue('');
    console.log(this.autolog);
    var _activeformconfigdetails = this.formConfigId + '*' + this.documentId + '*' + this.archiveyear;

  

    // this.formRenderService.sendtoautolog(_activeformconfigdetails).subscribe(
    //   (res) => {
    //     console.log(res);
    //   })
//     this.formRenderService.sendtoautolog(JSON.stringify(this.autolog)).subscribe(
//       (res) => {
// console.log(res);
//       })

  }

  loadproductline(productid, product, active) {   
    this.SpinnerService.show();
    this.formRenderService.LoadProductLine(productid, product, active).subscribe(
      (res) => {
        console.log(res);
        this.productline = JSON.parse(res[0].j);       
        this._dropdownSettings = {
          singleSelection: false,
          idField: 'ProductID',
          textField: 'Name',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 7,
          allowSearchFilter: true,
        };
        this.SpinnerService.hide();
      },      
      error => {
       
        this.SpinnerService.hide();
      });
    
    
  }
  loadproduct(productid, product, active) {
   
    this.SpinnerService.show();
    //let apitoken=this.localService.getJsonValue("apitoken");
    var apitoken=this.localService.getJsonValue('apitoken');
    this.formRenderService.LoadProduct(productid, product, active,apitoken).subscribe(
      (res) => {
        console.log(res);
        this.product = JSON.parse(res[0].j);
        this._dropdownSettings = {
          singleSelection: false,
          idField: 'ProductID',
          textField: 'Name',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 7,
          allowSearchFilter: true
        };
        this.productItems = '';
        this.product.forEach(element => {
          if (element.Name === 'Primary Source Documents') {
            this.productItems = [element];
          }
        });
        this.SpinnerService.hide();
      },

      error => {

        this.SpinnerService.hide();
      });
  }

  loadproductddl(productid, product, active) {
    
    this.SpinnerService.show();
    this.formRenderService.LoadProductddl(productid, product, active).subscribe(
      (res) => {
        console.log(res);
        this.product = JSON.parse(res[0].j);
        this._dropdownSettings = {
          singleSelection: false,
          idField: 'ProductID',
          textField: 'Name',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 7,
          allowSearchFilter: true
        };
        this.productItems = '';
        this.product.forEach(element => {
          if (element.Name === 'Primary Source Documents') {
            this.productItems = [element];
          }
        });
        this.SpinnerService.hide();
      },

      error => {

        this.SpinnerService.hide();
      });
  }

  onChange(eve) {
    
    if (eve.currentTarget.value != '0') {
      this.loadproductddl(eve.currentTarget.value, 'Null', 1);
    }
  }

  onItemDeSelect(eve) {
    
    if (eve.Name === 'Primary Source Documents') {
      var prod = [];
      this.productItems.forEach(element => {
        prod.push(element);
      });
      prod.push(eve);
      this.productItems = [];
      this.productItems = prod;
    }
    this._dropdownSettings = {
      singleSelection: false,
      idField: 'ProductID',
      textField: 'Name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 7,
      allowSearchFilter: true
    };
  }
  clear(){
  this.productItems='';
  this.formConfigForm.controls['ProductLine'].setValue('');
  this.formModalRef.hide()
   }

   selecttoggleViewStatus(eve){    
     console.log(eve.currentTarget.checked);
     if(eve.currentTarget.checked){
      this.showViewStatus=false;
     } else
     {
      this.showViewStatus=true;
     }

   }
}
